/* eslint-disable */
import { useState, useEffect, useRef, useCallback } from "react";
import * as XLSX from "xlsx";

// --- STORAGE ----------------------------------------------------------------
const STORAGE_KEY = "kaitana_v3";
const STORAGE_VER = 3;
const DEFAULT_DATA = {
  __version: STORAGE_VER,
  settings: { campStartTime: "08:30", autoAbsenceAlert: true },
  children: [], counselors: [], groups: [],
  trips: [], scores: [], tasks: [],
  attendance: {}, // { "YYYY-MM-DD": { childId: true/false } }
  announcements: [],
};
// Seed data removed - using MySQL API

function loadData() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) { saveData(SEED_DATA); return SEED_DATA; }
    const d = JSON.parse(raw);
    if (d.__version !== STORAGE_VER) return { ...DEFAULT_DATA, ...d, __version: STORAGE_VER };
    return d;
  } catch { return SEED_DATA; }
}
function saveData(d) { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(d)); } catch {} }
function uid() { return Math.random().toString(36).slice(2, 10); }
function today() { return new Date().toISOString().slice(0, 10); }
function fmtDate(s) { if (!s) return ""; try { return new Date(s).toLocaleDateString("he-IL"); } catch { return s; } }

// --- DESIGN TOKENS ----------------------------------------------------------
const T = {
  navy:"#0F172A", purple:"#7C3AED", purpleL:"#8B5CF6", purpleXL:"#EDE9FE",
  teal:"#0D9488", tealL:"#CCFBF1", coral:"#F43F5E", coralL:"#FFE4E6",
  amber:"#F59E0B", amberL:"#FEF3C7", slate:"#475569", slateL:"#F1F5F9",
  border:"#E2E8F0", white:"#FFFFFF", text:"#1E293B", muted:"#94A3B8",
};
const GROUP_COLORS = ["#7C3AED","#0D9488","#F43F5E","#F59E0B","#3B82F6","#EC4899","#10B981","#6366F1"];

// --- CSS --------------------------------------------------------------------
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Heebo:wght@300;400;500;600;700;800;900&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
html,body{height:100%;font-family:'Heebo',sans-serif;direction:rtl;background:#F1F5F9;color:#1E293B}
::-webkit-scrollbar{width:5px;height:5px}::-webkit-scrollbar-thumb{background:#CBD5E1;border-radius:99px}
.shell{display:flex;height:100vh;overflow:hidden}
.sidebar{width:230px;background:#0F172A;display:flex;flex-direction:column;flex-shrink:0;overflow-y:auto}
.main-area{flex:1;display:flex;flex-direction:column;overflow:hidden}
.topbar{height:58px;background:#fff;border-bottom:1px solid #E2E8F0;display:flex;align-items:center;justify-content:space-between;padding:0 24px;flex-shrink:0;gap:12px}
.page{flex:1;overflow-y:auto;padding:24px}
.sb-brand{padding:20px 16px 14px;border-bottom:1px solid rgba(255,255,255,.07)}
.sb-logo{font-size:20px;font-weight:900;color:#fff}
.sb-sub{font-size:11px;color:rgba(255,255,255,.35);margin-top:2px}
.sb-sec{padding:14px 14px 3px;font-size:9px;font-weight:800;color:rgba(255,255,255,.25);text-transform:uppercase;letter-spacing:1.2px}
.sb-item{display:flex;align-items:center;gap:9px;padding:9px 10px;margin:1px 8px;border-radius:9px;cursor:pointer;font-size:13px;font-weight:500;color:rgba(255,255,255,.55);transition:.12s}
.sb-item:hover{background:rgba(255,255,255,.07);color:#fff}
.sb-item.active{background:#7C3AED;color:#fff;font-weight:700}
.sb-icon{font-size:15px;width:20px;text-align:center}
.sb-footer{margin-top:auto;padding:14px;border-top:1px solid rgba(255,255,255,.07)}
.sb-reset{width:100%;padding:7px;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);color:rgba(255,255,255,.4);border-radius:7px;font-family:'Heebo';font-size:11px;cursor:pointer;transition:.15s}
.sb-reset:hover{background:rgba(244,63,94,.2);color:#F43F5E;border-color:#F43F5E}
.tb-title{font-size:17px;font-weight:800;flex-shrink:0}
.tb-chips{display:flex;gap:8px;flex:1;overflow:hidden}
.chip{display:inline-flex;align-items:center;gap:4px;padding:4px 10px;border-radius:99px;font-size:11px;font-weight:700;white-space:nowrap}
.chip-p{background:#EDE9FE;color:#7C3AED}.chip-t{background:#CCFBF1;color:#0D9488}
.chip-c{background:#FFE4E6;color:#F43F5E}.chip-s{background:#F1F5F9;color:#475569}
.ph{display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:20px;gap:12px;flex-wrap:wrap}
.ph h2{font-size:20px;font-weight:800}.ph p{font-size:12px;color:#94A3B8;margin-top:2px}
.ph-actions{display:flex;gap:8px;flex-wrap:wrap;align-items:center}
.btn{display:inline-flex;align-items:center;gap:5px;padding:8px 16px;border-radius:9px;border:none;cursor:pointer;font-family:'Heebo';font-size:12px;font-weight:700;transition:.12s;white-space:nowrap}
.btn-sm{padding:6px 12px;font-size:11px;border-radius:7px}
.btn-xs{padding:4px 8px;font-size:10px;border-radius:6px}
.btn-p{background:#7C3AED;color:#fff;box-shadow:0 2px 6px rgba(124,58,237,.3)}.btn-p:hover{background:#6D28D9}
.btn-t{background:#0D9488;color:#fff}.btn-t:hover{opacity:.9}
.btn-g{background:transparent;border:2px solid #E2E8F0;color:#475569}.btn-g:hover{border-color:#7C3AED;color:#7C3AED}
.btn-d{background:#F43F5E;color:#fff}.btn-d:hover{opacity:.9}
.btn-a{background:#F59E0B;color:#fff}.btn-a:hover{opacity:.9}
.srch{position:relative}.srch input{padding:8px 12px 8px 32px;border:2px solid #E2E8F0;border-radius:9px;font-family:'Heebo';font-size:12px;outline:none;width:200px;transition:.15s}
.srch input:focus{border-color:#7C3AED;width:240px}.srch::before{content:'🔍';position:absolute;left:9px;top:50%;transform:translateY(-50%);font-size:13px;pointer-events:none}
.stats{display:grid;grid-template-columns:repeat(auto-fill,minmax(150px,1fr));gap:12px;margin-bottom:20px}
.sc{background:#fff;border-radius:13px;padding:14px 16px;border:1px solid #E2E8F0}
.sc .v{font-size:24px;font-weight:900;line-height:1}.sc .l{font-size:11px;color:#94A3B8;margin-top:3px}.sc .i{font-size:20px;margin-bottom:6px}
.card{background:#fff;border-radius:14px;border:1px solid #E2E8F0;overflow:hidden;margin-bottom:16px}
.card-h{padding:14px 18px;border-bottom:1px solid #E2E8F0;display:flex;align-items:center;justify-content:space-between}
.card-h h3{font-size:14px;font-weight:700}.card-b{padding:18px}
.tw{overflow-x:auto}
table{width:100%;border-collapse:collapse;font-size:12px}
th{padding:9px 12px;text-align:right;font-size:10px;font-weight:800;color:#94A3B8;background:#F8FAFC;border-bottom:1px solid #E2E8F0;white-space:nowrap}
td{padding:10px 12px;border-bottom:1px solid #F8FAFC;color:#1E293B;vertical-align:middle}
tr:last-child td{border-bottom:none}tr:hover td{background:#FAFBFF}
.tda{display:flex;gap:5px;justify-content:flex-end}
.av{width:32px;height:32px;border-radius:50%;font-weight:800;font-size:12px;display:inline-flex;align-items:center;justify-content:center;flex-shrink:0}
.overlay{position:fixed;inset:0;background:rgba(15,23,42,.6);z-index:300;display:flex;align-items:center;justify-content:center;padding:16px;backdrop-filter:blur(3px)}
.modal{background:#fff;border-radius:18px;width:100%;max-width:540px;max-height:92vh;overflow-y:auto;box-shadow:0 20px 60px rgba(0,0,0,.25)}
.modal.wide{max-width:700px}.modal.narrow{max-width:400px}
.mh{padding:18px 22px 14px;display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid #E2E8F0;position:sticky;top:0;background:#fff;z-index:1}
.mh h3{font-size:16px;font-weight:800}
.mc{background:none;border:none;font-size:18px;cursor:pointer;color:#94A3B8;width:30px;height:30px;border-radius:7px;display:flex;align-items:center;justify-content:center}.mc:hover{background:#F1F5F9}
.mb{padding:20px 22px}.mf{padding:14px 22px;border-top:1px solid #E2E8F0;display:flex;gap:8px;justify-content:flex-end}
.fg{display:grid;grid-template-columns:1fr 1fr;gap:12px}
.fg.s1{grid-template-columns:1fr}.field{display:flex;flex-direction:column;gap:4px}
.field.sp{grid-column:1/-1}.field label{font-size:11px;font-weight:700;color:#475569}
.field input,.field select,.field textarea{padding:9px 12px;border:2px solid #E2E8F0;border-radius:9px;font-family:'Heebo';font-size:12px;outline:none;background:#FAFAFA;transition:.15s;color:#1E293B;width:100%}
.field input:focus,.field select:focus,.field textarea:focus{border-color:#7C3AED;background:#fff}
.field textarea{resize:vertical;min-height:70px}.field .hint{font-size:10px;color:#94A3B8}
.uz{border:2px dashed #E2E8F0;border-radius:11px;padding:22px;text-align:center;cursor:pointer;transition:.15s;background:#F8FAFC}
.uz:hover,.uz.drag{border-color:#7C3AED;background:#EDE9FE}
.uz .ui{font-size:28px;margin-bottom:6px}.uz p{font-size:12px;color:#94A3B8}.uz strong{color:#7C3AED}
.empty{text-align:center;padding:48px 16px}
.empty .ei{font-size:40px;margin-bottom:10px;opacity:.4}.empty h4{font-size:14px;font-weight:700;color:#475569}.empty p{font-size:12px;color:#94A3B8;margin-top:3px}
.alert{border-radius:9px;padding:10px 14px;font-size:12px;font-weight:500;margin-bottom:14px}
.alert-t{background:#CCFBF1;color:#115E59;border:1px solid #99F6E4}
.alert-c{background:#FFE4E6;color:#9F1239;border:1px solid #FECDD3}
.alert-a{background:#FEF3C7;color:#92400E;border:1px solid #FCD34D}
.gpill{display:inline-flex;align-items:center;gap:3px;padding:2px 8px;border-radius:99px;font-size:10px;font-weight:700;color:#fff}
.tabs{display:flex;gap:2px;border-bottom:2px solid #E2E8F0;margin-bottom:16px}
.tab{padding:8px 14px;border:none;background:none;font-family:'Heebo';font-size:12px;font-weight:700;color:#94A3B8;cursor:pointer;border-bottom:3px solid transparent;margin-bottom:-2px;transition:.12s}
.tab.active{color:#7C3AED;border-bottom-color:#7C3AED}
.toggle{width:44px;height:24px;border-radius:12px;border:none;cursor:pointer;transition:.2s;position:relative;flex-shrink:0}
.toggle.on{background:#7C3AED}.toggle.off{background:#CBD5E1}
.toggle::after{content:'';position:absolute;width:18px;height:18px;border-radius:50%;background:#fff;top:3px;transition:.2s;box-shadow:0 1px 3px rgba(0,0,0,.2)}
.toggle.on::after{right:3px}.toggle.off::after{left:3px}
.score-bar{height:8px;background:#F1F5F9;border-radius:99px;overflow:hidden;margin-top:4px}
.score-fill{height:100%;border-radius:99px;transition:width .5s}
.skill-pill{display:inline-flex;align-items:center;padding:3px 10px;border-radius:99px;font-size:10px;font-weight:700;cursor:pointer;border:2px solid transparent;transition:.12s;user-select:none}
.att-btn{width:30px;height:30px;border-radius:50%;border:2px solid #E2E8F0;background:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;font-size:13px;transition:.15s;font-family:'Heebo'}
.att-btn.yes{background:#CCFBF1;border-color:#0D9488;color:#0D9488}
.att-btn.no{background:#FFE4E6;border-color:#F43F5E;color:#F43F5E}
.att-btn.none{color:#94A3B8}
.flex{display:flex}.gap1{gap:4px}.gap2{gap:8px}.gap3{gap:12px}.ic{align-items:center}.jb{justify-content:space-between}.jc{justify-content:center}.fw{flex-wrap:wrap}
.mt1{margin-top:4px}.mt2{margin-top:8px}.mt3{margin-top:12px}.mt4{margin-top:16px}.mb2{margin-bottom:8px}.mb3{margin-bottom:12px}.mb4{margin-bottom:16px}
.fw7{font-weight:700}.fw8{font-weight:800}.fs11{font-size:11px}.fs12{font-size:12px}.fs13{font-size:13px}.muted{color:#94A3B8}
.divider{height:1px;background:#E2E8F0;margin:12px 0}
`;

// --- HELPERS -----------------------------------------------------------------
function initials(n=""){const p=n.trim().split(" ");return(p[0]?.[0]||"")+(p[1]?.[0]||"");}
function Av({name,color=T.purple,size=32}){
  return <div className="av" style={{width:size,height:size,background:color+"22",color,fontSize:size*0.38}}>{initials(name)||"?"}</div>;
}
function Fld({label,hint,sp,children}){
  return <div className={`field${sp?" sp":""}`}>{label&&<label>{label}</label>}{children}{hint&&<span className="hint">{hint}</span>}</div>;
}
function Srch({value,onChange,ph="חיפוש..."}){
  return <div className="srch"><input value={value} onChange={e=>onChange(e.target.value)} placeholder={ph}/></div>;
}
function Modal({open,onClose,title,children,footer,wide,narrow}){
  if(!open)return null;
  return <div className="overlay" onClick={e=>e.target===e.currentTarget&&onClose()}>
    <div className={`modal${wide?" wide":""}${narrow?" narrow":""}`}>
      <div className="mh"><h3>{title}</h3><button className="mc" onClick={onClose}>✕</button></div>
      <div className="mb">{children}</div>
      {footer&&<div className="mf">{footer}</div>}
    </div>
  </div>;
}
function UZ({onFile,label="גרור Excel או לחץ לבחירה"}){
  const [drag,setDrag]=useState(false);const ref=useRef();
  return <div className={`uz${drag?" drag":""}`}
    onClick={()=>ref.current.click()}
    onDragOver={e=>{e.preventDefault();setDrag(true);}}
    onDragLeave={()=>setDrag(false)}
    onDrop={e=>{e.preventDefault();setDrag(false);const f=e.dataTransfer.files[0];if(f)onFile(f);}}>
    <div className="ui">📊</div><p><strong>{label}</strong></p><p style={{fontSize:10,marginTop:3}}>xlsx / xls</p>
    <input ref={ref} type="file" accept=".xlsx,.xls" style={{display:"none"}} onChange={e=>{if(e.target.files[0])onFile(e.target.files[0]);}}/>
  </div>;
}
function Toggle({on,onToggle}){
  return <button className={`toggle${on?" on":" off"}`} onClick={onToggle}/>;
}

// --- EXCEL PARSERS -----------------------------------------------------------
function xlxParse(file){
  return new Promise((res,rej)=>{
    const r=new FileReader();
    r.onload=e=>{try{const wb=XLSX.read(e.target.result,{type:"array"});const ws=wb.Sheets[wb.SheetNames[0]];res(XLSX.utils.sheet_to_json(ws,{defval:""}));}catch(err){rej(err);}};
    r.readAsArrayBuffer(file);
  });
}
async function parseChildren(file){
  const rows=await xlxParse(file);
  return rows.map(r=>({
    id:uid(),name:String(r["שם הילד/ה"]||r["שם"]||"").trim(),
    lastName:String(r["שם משפחה"]||"").trim(),
    grade:String(r["בני מסיים כיתה"]||"").trim(),
    fatherName:String(r["שם האבא"]||"").trim(),
    motherName:String(r["שם האמא"]||"").trim(),
    fatherPhone:String(r["טלפון ליצירת קשר(אבא)"]||r["טלפון אבא"]||"").trim(),
    motherPhone:String(r["טלפון ליצירת קשר (אמא)"]||r["טלפון אמא"]||"").trim(),
    email:String(r["דואר אלקטרוני"]||"").trim(),
    city:String(r["עיר"]||"").trim(),address:String(r["רחוב ומספר"]||"").trim(),
    birthDate:String(r["ת.לידה לועזי - כתבו במדויק בפורמט כזה 01/01/2000"]||r["תאריך לידה"]||"").trim(),
    idNumber:String(r["ת.ז הילד/ה"]||"").trim(),
    shirtSize:String(r["מידת חולצה"]||"").trim(),
    swimming:String(r["כישורי שחיה"]||"").trim(),
    allergy:String(r["האם קיימת רגישות או אלרגיה"]||"לא").trim(),
    allergyDetail:String(r["פירוט אודות רגישות/אלרגיה:"]||"").trim(),
    exitPermission:String(r["מי יכול להוציא את הילד מהקייטנה"]||"").trim(),
    coupon:String(r["מספר קופון"]||"").trim(),
    payment:Number(r['סה"כ']||0),groupId:"",notes:"",
  })).filter(c=>c.name);
}
async function parseCounselors(file){
  const rows=await xlxParse(file);
  return rows.map(r=>({
    id:uid(),name:String(r["שם"]||r["שם מלא"]||"").trim(),
    phone:String(r["טלפון"]||"").trim(),idNumber:String(r["מספר ת.ז."]||r["ת.ז"]||"").trim(),
    birthDate:String(r["תאריך לידה"]||"").trim(),shirtSize:String(r["מידת חולצה"]||"").trim(),
    school:String(r["מקום לימודים"]||"").trim(),email:String(r["אימייל"]||"").trim(),
    skills:String(r["כישורים מיוחדים"]||"").trim(),skillsOther:"",groupId:"",notes:"",
  })).filter(c=>c.name);
}

// --- EMPTY FORMS -------------------------------------------------------------
const EC={id:"",name:"",lastName:"",grade:"",fatherName:"",motherName:"",fatherPhone:"",motherPhone:"",email:"",city:"",address:"",birthDate:"",idNumber:"",shirtSize:"",swimming:"",allergy:"לא",allergyDetail:"",exitPermission:"",coupon:"",payment:0,groupId:"",notes:""};
const ECS={id:"",name:"",phone:"",idNumber:"",birthDate:"",shirtSize:"",school:"",email:"",skills:"",skillsOther:"",groupId:"",notes:""};
const EG={id:"",name:"",color:GROUP_COLORS[0],notes:""};
const ET={id:"",name:"",date:"",returnDate:"",locations:[],stops:1,gear:{water:"",flashlight:false,swimsuit:false,clothes:false,prayer:false,extraMeal:false,other:""},groupIds:[],attendance:{},counselorTrip:{},notes:""};
const ETASK={id:"",title:"",points:10,type:"group",category:"activity",notes:""};

const GRADES=["מסיים א'","מסיים ב'","מסיים ג'","מסיים ד'","מסיים ה'","מסיים ו'","מסיים ז'"];
const GRADE_IDX=g=>GRADES.indexOf(g?.trim());
const SKILLS=["מע\"ר","צלם","מעצב","אחר"];
const SCORE_CATS={activity:{l:"פעילות",ic:"⚽",c:T.teal},learning:{l:"למידה",ic:"📚",c:T.purple},social:{l:"חברתיות",ic:"🤝",c:T.amber},creativity:{l:"יצירתיות",ic:"🎨",c:T.coral}};

// ════════════════════════════════════════════════
// CHILD FORM
// ════════════════════════════════════════════════
function ChildForm({d,set}){
  const f=k=>({value:d[k]||"",onChange:e=>set({...d,[k]:e.target.value})});
  return <div className="fg">
    <Fld label="שם פרטי"><input {...f("name")}/></Fld>
    <Fld label="שם משפחה"><input {...f("lastName")}/></Fld>
    <Fld label="ת.ז. ילד/ה"><input {...f("idNumber")}/></Fld>
    <Fld label="כיתה מסיים"><select {...f("grade")}><option value="">בחר...</option>{GRADES.map(g=><option key={g} value={g}>{g}</option>)}</select></Fld>
    <Fld label="תאריך לידה"><input placeholder="01/01/2000" {...f("birthDate")}/></Fld>
    <Fld label="מידת חולצה"><select {...f("shirtSize")}><option value="">בחר...</option>{["6","8","10","12","14","16","S","M","L","XL"].map(s=><option key={s}>{s}</option>)}</select></Fld>
    <Fld label="שם האבא"><input {...f("fatherName")}/></Fld>
    <Fld label="טלפון אבא"><input {...f("fatherPhone")}/></Fld>
    <Fld label="שם האמא"><input {...f("motherName")}/></Fld>
    <Fld label="טלפון אמא"><input {...f("motherPhone")}/></Fld>
    <Fld label="אימייל" sp><input type="email" {...f("email")}/></Fld>
    <Fld label="עיר"><input {...f("city")}/></Fld>
    <Fld label="רחוב ומספר"><input {...f("address")}/></Fld>
    <Fld label="כישורי שחייה"><select {...f("swimming")}><option value="">בחר...</option><option value="בני בעל כישורי שחיה">יודע ✓</option><option value="בני אינו יודע לשחות">אינו יודע</option></select></Fld>
    <Fld label="מי יכול להוציא"><select {...f("exitPermission")}><option value="">בחר...</option>{["שניהם","אבא","אמא","עצמאית"].map(o=><option key={o}>{o}</option>)}</select></Fld>
    <Fld label="אלרגיה"><select {...f("allergy")}><option value="לא">לא</option><option value="כן">כן</option></select></Fld>
    <Fld label="פירוט אלרגיה"><input {...f("allergyDetail")}/></Fld>
    <Fld label="קוד קופון"><input {...f("coupon")}/></Fld>
    <Fld label="תשלום ₪"><input type="number" {...f("payment")}/></Fld>
    <Fld label="הערות" sp><textarea {...f("notes")}/></Fld>
  </div>;
}

// ════════════════════════════════════════════════
// COUNSELOR FORM
// ════════════════════════════════════════════════
function CounselorForm({d,set}){
  const f=k=>({value:d[k]||"",onChange:e=>set({...d,[k]:e.target.value})});
  const skills=(d.skills||"").split(",").map(s=>s.trim()).filter(Boolean);
  const tog=s=>{const a=skills.includes(s)?skills.filter(x=>x!==s):[...skills,s];set({...d,skills:a.join(", ")});};
  return <div className="fg">
    <Fld label="שם מלא" sp><input {...f("name")}/></Fld>
    <Fld label="מספר ת.ז."><input {...f("idNumber")}/></Fld>
    <Fld label="תאריך לידה"><input placeholder="01/01/2000" {...f("birthDate")}/></Fld>
    <Fld label="טלפון"><input {...f("phone")}/></Fld>
    <Fld label="אימייל"><input type="email" {...f("email")}/></Fld>
    <Fld label="מקום לימודים"><input {...f("school")}/></Fld>
    <Fld label="מידת חולצה"><select {...f("shirtSize")}><option value="">בחר...</option>{["S","M","L","XL","XXL"].map(s=><option key={s}>{s}</option>)}</select></Fld>
    <Fld label="כישורים מיוחדים" sp>
      <div className="flex fw gap2 mb2">{SKILLS.map(s=>(
        <span key={s} className="skill-pill" onClick={()=>tog(s)}
          style={{background:skills.includes(s)?T.purple+"22":"#F1F5F9",color:skills.includes(s)?T.purple:T.slate,borderColor:skills.includes(s)?T.purple:"#E2E8F0"}}>
          {s}{skills.includes(s)?" ✓":""}
        </span>
      ))}</div>
      {skills.includes("אחר")&&<input placeholder="פרט כישור..." {...f("skillsOther")}/>}
    </Fld>
    <Fld label="הערות" sp><textarea {...f("notes")}/></Fld>
  </div>;
}

// ════════════════════════════════════════════════
// PAGE: CHILDREN
// ════════════════════════════════════════════════
function ChildrenPage({data,setData,api,onRefresh}){
  const [q,setQ]=useState("");
  const [modal,setModal]=useState(null);
  const [form,setForm]=useState({...EC});
  const [imp,setImp]=useState([]);const [impMsg,setImpMsg]=useState("");
  const [view,setView]=useState(null);
  const [mainTab,setMainTab]=useState("children");

  const siblings={};
  data.children.forEach(c=>{const k=c.fatherPhone||c.motherPhone;if(k){siblings[k]=siblings[k]||[];siblings[k].push(c.id);}});
  const sibCount=c=>{const k=c.fatherPhone||c.motherPhone;return k?(siblings[k]?.length||1)-1:0;};
  const sibList=c=>{const k=c.fatherPhone||c.motherPhone;return k?data.children.filter(x=>x.id!==c.id&&(x.fatherPhone===k||x.motherPhone===k)):[];};
  const getGr=id=>data.groups.find(g=>g.id===id);

  // Build parents list - one entry per family (keyed by phone)
  const parentsMap={};
  data.children.forEach(c=>{
    const key=c.fatherPhone||c.motherPhone||c.id;
    if(!parentsMap[key]) parentsMap[key]={fatherName:c.fatherName,motherName:c.motherName,fatherPhone:c.fatherPhone,motherPhone:c.motherPhone,email:c.email,children:[]};
    parentsMap[key].children.push(c);
  });
  const parentsList=Object.values(parentsMap).filter(p=>p.fatherName||p.motherName||p.fatherPhone||p.motherPhone);

  const sorted=[...data.children]
    .filter(c=>!q||`${c.name} ${c.lastName} ${c.grade} ${c.city}`.includes(q))
    .sort((a,b)=>GRADE_IDX(a.grade)-GRADE_IDX(b.grade)||(a.lastName||"").localeCompare(b.lastName||"","he"));

  async function save(){
    try{
      if(form.id&&data.children.find(c=>c.id===form.id)){
        await api.updateChild(form.id,form);
      } else {
        await api.createChild(form);
      }
      await onRefresh();
      setModal(null);
    }catch(e){alert('שגיאה: '+e.message);}
  }
  async function del(id){if(!window.confirm("למחוק חניך?"))return;
    try{await api.deleteChild(id);await onRefresh();}catch(e){alert('שגיאה: '+e.message);}
  }

  async function handleFile(file){
    try{setImpMsg("טוען...");const rows=await parseChildren(file);setImp(rows);setImpMsg(`נמצאו ${rows.length} חניכים`);}
    catch{setImpMsg("שגיאה בטעינת הקובץ");}
  }
  async function doImport(){
    try{
      await api.importChildren(imp);
      await onRefresh();
      setImp([]);setImpMsg("");setModal(null);
    }catch(e){setImpMsg("שגיאה: "+e.message);}
  }

  return <div className="page">
    <div className="ph">
      <div><h2>👦 חניכים</h2><p>{data.children.length} חניכים רשומים</p></div>
      <div className="ph-actions">
        <Srch value={q} onChange={setQ}/>
        <button className="btn btn-g btn-sm" onClick={()=>setModal("imp")}>📊 ייבוא Excel</button>
        <button className="btn btn-p btn-sm" onClick={()=>{setForm({...EC,id:uid()});setModal("add");}}>+ צור חניך</button>
      </div>
    </div>
    <div className="stats">
      {[{i:"👦",v:data.children.length,l:"סה\"כ חניכים",c:T.purple},
        {i:"🏊",v:data.children.filter(c=>c.swimming?.includes("בעל")).length,l:"יודעי שחייה",c:T.teal},
        {i:"⚠️",v:data.children.filter(c=>c.allergy?.includes("כן")).length,l:"עם אלרגיה",c:T.coral},
        {i:"👨‍👩‍👦",v:parentsList.length,l:"משפחות",c:T.amber},
      ].map(s=><div key={s.l} className="sc"><div className="i">{s.i}</div><div className="v" style={{color:s.c}}>{s.v}</div><div className="l">{s.l}</div></div>)}
    </div>

    <div className="tabs">{[["children","חניכים"],["parents","הורים"]].map(([v,l])=><button key={v} className={`tab${mainTab===v?" active":""}`} onClick={()=>setMainTab(v)}>{l}</button>)}</div>

    {mainTab==="parents"&&<div className="card"><div className="tw"><table>
      <thead><tr><th>שם האבא</th><th>שם האמא</th><th>טלפון אבא</th><th>טלפון אמא</th><th>אימייל</th><th>ילדים בקייטנה</th></tr></thead>
      <tbody>
        {parentsList.length===0&&<tr><td colSpan={6}><div className="empty"><div className="ei">👨‍👩‍👦</div><h4>אין הורים עדיין</h4></div></td></tr>}
        {parentsList.sort((a,b)=>(a.fatherName||a.motherName||"").localeCompare(b.fatherName||b.motherName||"","he")).map((p,i)=>(
          <tr key={i}>
            <td><span className="fw7">{p.fatherName||"-"}</span></td>
            <td><span className="fw7">{p.motherName||"-"}</span></td>
            <td><a href={`tel:${p.fatherPhone}`} style={{color:T.teal,textDecoration:"none",fontSize:12}}>{p.fatherPhone||"-"}</a></td>
            <td><a href={`tel:${p.motherPhone}`} style={{color:T.teal,textDecoration:"none",fontSize:12}}>{p.motherPhone||"-"}</a></td>
            <td className="fs11 muted">{p.email||"-"}</td>
            <td>
              <div className="flex fw gap1">
                {p.children.map(c=>{const gr=getGr(c.groupId);return(
                  <span key={c.id} style={{display:"inline-flex",alignItems:"center",gap:4,background:gr?gr.color+"22":T.slateL,border:`1px solid ${gr?gr.color:T.border}`,borderRadius:99,padding:"2px 8px",fontSize:11,fontWeight:700,color:gr?gr.color:T.slate}}>
                    {c.name} {c.lastName}
                    {sibCount(c)>0&&<span style={{fontSize:9,background:T.amberL,color:T.amber,borderRadius:99,padding:"1px 4px"}}>אח</span>}
                  </span>);})}
              </div>
            </td>
          </tr>))}
      </tbody>
    </table></div></div>}

    {mainTab==="children"&&<><div className="card"><div className="tw"><table>
      <thead><tr><th>חניך</th><th>כיתה</th><th>קבוצה</th><th>עיר</th><th>טלפון אבא</th><th>טלפון אמא</th><th>שחייה</th><th>אלרגיה</th><th>אחים</th><th>קבוצה</th><th></th></tr></thead>
      <tbody>
        {sorted.length===0&&<tr><td colSpan={10}><div className="empty"><div className="ei">👦</div><h4>אין חניכים</h4><p>הוסף חניך או ייבא מ-Excel</p></div></td></tr>}
        {sorted.map(c=>{const gr=getGr(c.groupId);const sb=sibCount(c);return(
          <tr key={c.id} style={{cursor:"pointer"}} onClick={()=>{setView(c);setModal("view");}}>
            <td><div className="flex ic gap2"><Av name={`${c.name} ${c.lastName}`}/><div><div className="fw7">{c.name} {c.lastName}</div><div className="muted fs11">{c.idNumber}</div></div></div></td>
            <td>{c.grade||"-"}</td>
            <td>{gr?<span className="gpill" style={{background:gr.color}}>{gr.name}</span>:<span className="muted">-</span>}</td>
            <td>{c.city||"-"}</td><td className="fs11">{c.fatherPhone||"-"}</td><td className="fs11">{c.motherPhone||"-"}</td>
            <td>{c.swimming?.includes("בעל")?<span className="chip chip-t">✓ יודע</span>:<span className="muted fs11">לא יודע</span>}</td>
            <td>{c.allergy?.includes("כן")?<span className="chip chip-c">⚠️ כן</span>:<span className="muted fs11">לא</span>}</td>
            <td>{sb>0?<span className="chip chip-a">+{sb} אחים</span>:"-"}</td>
            <td onClick={e=>e.stopPropagation()}>
              <select value={c.groupId||""} onChange={async e=>{const gid=e.target.value;try{await api.updateChild(c.id,{...c,group_id:gid||null,groupId:gid});await onRefresh();}catch(ex){alert(ex.message);}}} style={{padding:"4px 6px",border:"2px solid #E2E8F0",borderRadius:7,fontFamily:"Heebo",fontSize:11,outline:"none",maxWidth:90}}>
                <option value="">ללא קבוצה</option>
                {data.groups.map(g=><option key={g.id} value={g.id}>{g.name}</option>)}
              </select>
            </td>
            <td onClick={e=>e.stopPropagation()}><div className="tda">
              <button className="btn btn-g btn-xs" onClick={()=>{setForm({...c});setModal("edit");}}>✏️</button>
              <button className="btn btn-d btn-xs" onClick={()=>del(c.id)}>🗑️</button>
            </div></td>
          </tr>);})}
      </tbody>
    </table></div></div></> }

    <Modal open={modal==="add"||modal==="edit"} onClose={()=>setModal(null)} title={modal==="add"?"➕ צור חניך":"✏️ עריכת חניך"} wide
      footer={<><button className="btn btn-g" onClick={()=>setModal(null)}>ביטול</button><button className="btn btn-p" onClick={save}>שמור</button></>}>
      <ChildForm d={form} set={setForm}/>
    </Modal>

    <Modal open={modal==="view"} onClose={()=>setModal(null)} title={`📋 ${view?.name} ${view?.lastName}`} wide>
      {view&&<div>
        <div className="fg">{[["ת.ז.",view.idNumber],["כיתה",view.grade],["תאריך לידה",view.birthDate],["מידת חולצה",view.shirtSize],["שם האבא",view.fatherName],["טלפון אבא",view.fatherPhone],["שם האמא",view.motherName],["טלפון אמא",view.motherPhone],["אימייל",view.email],["עיר",view.city],["כתובת",view.address],["שחייה",view.swimming],["מי מוציא",view.exitPermission],["אלרגיה",view.allergy],["פירוט",view.allergyDetail],["קופון",view.coupon],["תשלום",`₪${view.payment}`],["הערות",view.notes]].filter(([,v])=>v).map(([k,v])=>(
          <div key={k} style={{background:T.slateL,borderRadius:9,padding:"9px 12px"}}>
            <div className="fs11 muted fw7">{k}</div><div className="fs12 fw7 mt1">{v}</div>
          </div>))}
        </div>
        <div className="flex jb mt4">
          <span/>
          <button className="btn btn-p btn-sm" onClick={()=>{setForm({...view});setModal("edit");}}>✏️ ערוך</button>
        </div>
      </div>}
    </Modal>

    <Modal open={modal==="imp"} onClose={()=>{setModal(null);setImp([]);setImpMsg("");}} title="📊 ייבוא חניכים מ-Excel"
      footer={imp.length>0?<><button className="btn btn-g" onClick={()=>setModal(null)}>ביטול</button><button className="btn btn-p" onClick={doImport}>ייבא {imp.length} חניכים</button></>:null}>
      <UZ onFile={handleFile}/>
      {impMsg&&<div className="alert alert-t mt3">{impMsg}</div>}
      {imp.length>0&&<div className="tw mt3" style={{maxHeight:220,overflowY:"auto"}}><table>
        <thead><tr><th>שם</th><th>כיתה</th><th>עיר</th><th>טלפון אבא</th></tr></thead>
        <tbody>{imp.map((c,i)=><tr key={i}><td>{c.name} {c.lastName}</td><td>{c.grade}</td><td>{c.city}</td><td>{c.fatherPhone}</td></tr>)}</tbody>
      </table></div>}
    </Modal>
  </div>;}

// ════════════════════════════════════════════════
// PAGE: COUNSELORS
// ════════════════════════════════════════════════
function CounselorsPage({data,setData,api,onRefresh}){
  const [q,setQ]=useState("");
  const [modal,setModal]=useState(null);
  const [form,setForm]=useState({...ECS});
  const [imp,setImp]=useState([]);const [impMsg,setImpMsg]=useState("");
  const getGr=id=>data.groups.find(g=>g.id===id);
  const filt=data.counselors.filter(c=>!q||`${c.name} ${c.phone} ${c.school}`.includes(q));

  async function save(){
    try{
      if(form.id&&data.counselors.find(c=>c.id===form.id)){await api.updateCounselor(form.id,form);}
      else{await api.createCounselor(form);}
      await onRefresh();setModal(null);
    }catch(e){alert("שגיאה: "+e.message);}
  }
  async function del(id){if(!window.confirm("למחוק?"))return;
    try{await api.deleteCounselor(id);await onRefresh();}catch(e){alert("שגיאה: "+e.message);}
  }
  async function handleFile(file){try{setImpMsg("טוען...");const rows=await parseCounselors(file);setImp(rows);setImpMsg(`נמצאו ${rows.length} מדריכים`);}catch{setImpMsg("שגיאה");}}
  function doImport(){setData(d=>({...d,counselors:[...d.counselors,...imp]}));setImp([]);setImpMsg("");setModal(null);}

  return <div className="page">
    <div className="ph">
      <div><h2>🧑‍🏫 מדריכים</h2><p>{data.counselors.length} מדריכים</p></div>
      <div className="ph-actions">
        <Srch value={q} onChange={setQ}/>
        <button className="btn btn-g btn-sm" onClick={()=>setModal("imp")}>📊 ייבוא Excel</button>
        <button className="btn btn-p btn-sm" onClick={()=>{setForm({...ECS,id:uid()});setModal("add");}}>+ הוסף מדריך</button>
      </div>
    </div>
    <div className="card"><div className="tw"><table>
      <thead><tr><th>שם</th><th>ת.ז.</th><th>טלפון</th><th>לימודים</th><th>כישורים</th><th>חולצה</th><th>קבוצה</th><th></th></tr></thead>
      <tbody>
        {filt.length===0&&<tr><td colSpan={8}><div className="empty"><div className="ei">🧑‍🏫</div><h4>אין מדריכים</h4><p>הוסף מדריך או ייבא מ-Excel</p></div></td></tr>}
        {filt.map(c=>{const gr=getGr(c.groupId);const sk=(c.skills||"").split(",").filter(Boolean);return(
          <tr key={c.id}>
            <td><div className="flex ic gap2"><Av name={c.name} color={T.teal}/><div><div className="fw7">{c.name}</div><div className="muted fs11">{c.email}</div></div></div></td>
            <td className="fs11">{c.idNumber||"-"}</td><td className="fs11">{c.phone||"-"}</td>
            <td className="fs11">{c.school||"-"}</td>
            <td>{sk.map(s=><span key={s} className="chip chip-p" style={{marginLeft:3,fontSize:9}}>{s.trim()}</span>)}</td>
            <td>{c.shirtSize||"-"}</td>
            <td>
              <select value={c.groupId||""} onChange={async e=>{const gid=e.target.value;try{await api.updateCounselor(c.id,{...c,group_id:gid||null,groupId:gid});await onRefresh();}catch(ex){alert(ex.message);}}} style={{padding:"4px 6px",border:"2px solid #E2E8F0",borderRadius:7,fontFamily:"Heebo",fontSize:11,outline:"none",maxWidth:90}}>
                <option value="">ללא קבוצה</option>
                {data.groups.map(g=><option key={g.id} value={g.id}>{g.name}</option>)}
              </select>
            </td>
            <td><div className="tda"><button className="btn btn-g btn-xs" onClick={()=>{setForm({...c});setModal("edit");}}>✏️</button><button className="btn btn-d btn-xs" onClick={()=>del(c.id)}>🗑️</button></div></td>
          </tr>);})}
      </tbody>
    </table></div></div>
    <Modal open={modal==="add"||modal==="edit"} onClose={()=>setModal(null)} title={modal==="add"?"➕ הוסף מדריך":"✏️ עריכת מדריך"} wide
      footer={<><button className="btn btn-g" onClick={()=>setModal(null)}>ביטול</button><button className="btn btn-p" onClick={save}>שמור</button></>}>
      <CounselorForm d={form} set={setForm}/>
    </Modal>
    <Modal open={modal==="imp"} onClose={()=>{setModal(null);setImp([]);setImpMsg("");}} title="📊 ייבוא מדריכים מ-Excel"
      footer={imp.length>0?<><button className="btn btn-g" onClick={()=>setModal(null)}>ביטול</button><button className="btn btn-p" onClick={doImport}>ייבא {imp.length}</button></>:null}>
      <UZ onFile={handleFile}/>
      {impMsg&&<div className="alert alert-t mt3">{impMsg}</div>}
      {imp.length>0&&<div className="tw mt3" style={{maxHeight:200,overflowY:"auto"}}><table><thead><tr><th>שם</th><th>טלפון</th><th>לימודים</th></tr></thead><tbody>{imp.map((c,i)=><tr key={i}><td>{c.name}</td><td>{c.phone}</td><td>{c.school}</td></tr>)}</tbody></table></div>}
    </Modal>
  </div>;
}

// ════════════════════════════════════════════════
// PAGE: GROUPS
// ════════════════════════════════════════════════
function GroupsPage({data,setData,api,onRefresh}){
  const [modal,setModal]=useState(null);
  const [form,setForm]=useState({...EG});
  const [active,setActive]=useState(null);
  const [tab,setTab]=useState("children");

  const gKids=g=>data.children.filter(c=>c.groupId===g.id);
  const gCns=g=>data.counselors.filter(c=>c.groupId===g.id);
  const unKids=data.children.filter(c=>!c.groupId);
  const unCns=data.counselors.filter(c=>!c.groupId);

  async function saveGr(){
    try{
      if(form.id&&data.groups.find(g=>g.id===form.id)){await api.updateGroup(form.id,form);}
      else{await api.createGroup(form);}
      await onRefresh();setModal(null);
    }catch(e){alert("שגיאה: "+e.message);}
  }
  async function delGr(id){if(!window.confirm("למחוק קבוצה?"))return;
    try{await api.deleteGroup(id);if(active?.id===id)setActive(null);await onRefresh();}catch(e){alert("שגיאה: "+e.message);}
  }
  async function assignKid(cid,gid){
    try{await api.updateChild(cid,{...data.children.find(c=>c.id===cid),group_id:gid,groupId:gid});await onRefresh();}catch(e){alert("שגיאה: "+e.message);}
  }
  async function assignCns(cid,gid){
    try{await api.updateCounselor(cid,{...data.counselors.find(c=>c.id===cid),group_id:gid,groupId:gid});await onRefresh();}catch(e){alert("שגיאה: "+e.message);}
  }

  function printGr(g){
    const kids=gKids(g);const cns=gCns(g);
    const w=window.open("","_blank");
    w.document.write(`<html dir="rtl"><head><meta charset="utf-8"><title>קבוצת ${g.name}</title>
    <style>body{font-family:Arial;direction:rtl;padding:24px}h1{color:${g.color};margin-bottom:4px}h3{margin-top:20px;margin-bottom:8px}table{width:100%;border-collapse:collapse}th,td{border:1px solid #ddd;padding:7px 10px;text-align:right}th{background:#f5f5f5;font-weight:bold;font-size:12px}td{font-size:12px}.badge{display:inline-block;padding:2px 8px;border-radius:99px;font-size:10px;font-weight:bold}</style></head>
    <body><h1>⛺ קבוצת ${g.name}</h1><p style="color:#666;margin-bottom:16px">${kids.length} חניכים | ${cns.length} מדריכים | הדפסה: ${new Date().toLocaleDateString("he-IL")}</p>
    <h3>👨‍🏫 מדריכים</h3><table><tr><th>שם</th><th>טלפון</th><th>אימייל</th><th>כישורים</th></tr>${cns.map(c=>`<tr><td><b>${c.name}</b></td><td>${c.phone}</td><td>${c.email}</td><td>${c.skills}</td></tr>`).join("")}</table>
    <h3>👦 חניכים</h3><table><tr><th>שם</th><th>כיתה</th><th>טלפון אבא</th><th>טלפון אמא</th><th>שחייה</th><th>אלרגיה</th></tr>${kids.map(c=>`<tr><td><b>${c.name} ${c.lastName}</b></td><td>${c.grade}</td><td>${c.fatherPhone}</td><td>${c.motherPhone}</td><td>${c.swimming?.includes("בעל")?"✓ יודע":"לא יודע"}</td><td>${c.allergy?.includes("כן")?'<span class="badge" style="background:#FFE4E6;color:#F43F5E">⚠️ כן</span>':"לא"}</td></tr>`).join("")}</table>
    </body></html>`);
    w.document.close();w.print();
  }

  return <div className="page">
    <div className="ph">
      <div><h2>⛺ קבוצות</h2><p>{data.groups.length} קבוצות</p></div>
      <button className="btn btn-p btn-sm" onClick={()=>{setForm({...EG,id:uid(),color:GROUP_COLORS[data.groups.length%GROUP_COLORS.length]});setModal("add");}}>+ צור קבוצה</button>
    </div>
    {data.groups.length===0&&<div className="empty"><div className="ei">⛺</div><h4>אין קבוצות עדיין</h4><p>לחץ "צור קבוצה" כדי להתחיל</p></div>}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(260px,1fr))",gap:14}}>
      {data.groups.map(g=>{const kids=gKids(g);const cns=gCns(g);return(
        <div key={g.id} className="card" style={{cursor:"pointer",borderTop:`4px solid ${g.color}`}} onClick={()=>{setActive(g);setTab("children");setModal("manage");}}>
          <div className="card-b">
            <div className="flex jb ic mb3">
              <div className="flex ic gap2"><div style={{width:12,height:12,borderRadius:"50%",background:g.color}}/><span style={{fontSize:16,fontWeight:800}}>{g.name}</span></div>
              <div className="flex gap1" onClick={e=>e.stopPropagation()}>
                <button className="btn btn-g btn-xs" onClick={()=>printGr(g)}>🖨️</button>
                <button className="btn btn-g btn-xs" onClick={()=>{setForm({...g});setModal("edit");}}>✏️</button>
                <button className="btn btn-d btn-xs" onClick={()=>delGr(g.id)}>🗑️</button>
              </div>
            </div>
            <div className="flex gap2">
              <div style={{background:T.purpleXL,borderRadius:9,padding:"10px 12px",flex:1,textAlign:"center"}}><div style={{fontSize:22,fontWeight:900,color:T.purple}}>{kids.length}</div><div className="fs11 muted">חניכים</div></div>
              <div style={{background:T.tealL,borderRadius:9,padding:"10px 12px",flex:1,textAlign:"center"}}><div style={{fontSize:22,fontWeight:900,color:T.teal}}>{cns.length}</div><div className="fs11 muted">מדריכים</div></div>
            </div>
            {kids.length>0&&<div className="flex fw gap1 mt3">{kids.slice(0,7).map(c=><Av key={c.id} name={`${c.name} ${c.lastName}`} color={g.color} size={28}/>)}{kids.length>7&&<div className="av" style={{width:28,height:28,background:T.slateL,color:T.muted,fontSize:10}}>+{kids.length-7}</div>}</div>}
          </div>
        </div>);})}
    </div>

    <Modal open={modal==="add"||modal==="edit"} onClose={()=>setModal(null)} title={modal==="add"?"➕ צור קבוצה":"✏️ עריכת קבוצה"}
      footer={<><button className="btn btn-g" onClick={()=>setModal(null)}>ביטול</button><button className="btn btn-p" onClick={saveGr}>שמור</button></>}>
      <div className="fg s1">
        <Fld label="שם הקבוצה"><input value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))}/></Fld>
        <Fld label="צבע"><div className="flex fw gap2 mt1">{GROUP_COLORS.map(c=><div key={c} onClick={()=>setForm(f=>({...f,color:c}))} style={{width:30,height:30,borderRadius:"50%",background:c,cursor:"pointer",border:`3px solid ${form.color===c?"#000":"transparent"}`,transition:".15s"}}/> )}</div></Fld>
        <Fld label="הערות"><textarea value={form.notes} onChange={e=>setForm(f=>({...f,notes:e.target.value}))}/></Fld>
      </div>
    </Modal>

    <Modal open={modal==="manage"&&!!active} onClose={()=>setModal(null)} title={`⛺ ניהול קבוצת ${active?.name}`} wide>
      {active&&<>
        <div className="tabs">{[["children","חניכים"],["counselors","מדריכים"]].map(([v,l])=><button key={v} className={`tab${tab===v?" active":""}`} onClick={()=>setTab(v)}>{l}</button>)}</div>
        {tab==="children"&&<>
          <div className="fw7 fs12 mb3">בקבוצה ({gKids(active).length})</div>
          {gKids(active).map(c=><div key={c.id} className="flex jb ic" style={{padding:"8px 0",borderBottom:`1px solid ${T.border}`}}>
            <div className="flex ic gap2"><Av name={`${c.name} ${c.lastName}`} color={active.color}/><span className="fw7">{c.name} {c.lastName}</span><span className="muted fs11">{c.grade}</span></div>
            <button className="btn btn-g btn-xs" onClick={()=>assignKid(c.id,"")}>הסר</button>
          </div>)}
          {unKids.length>0&&<><div className="divider"/><div className="fw7 fs12 mb3 muted">ללא קבוצה ({unKids.length})</div>
          {unKids.map(c=><div key={c.id} className="flex jb ic" style={{padding:"8px 0",borderBottom:`1px solid ${T.border}`}}>
            <div className="flex ic gap2"><Av name={`${c.name} ${c.lastName}`}/><span>{c.name} {c.lastName}</span><span className="muted fs11">{c.grade}</span></div>
            <button className="btn btn-p btn-xs" onClick={()=>assignKid(c.id,active.id)}>+ שייך</button>
          </div>)}</>}
        </>}
        {tab==="counselors"&&<>
          <div className="fw7 fs12 mb3">בקבוצה ({gCns(active).length})</div>
          {gCns(active).map(c=><div key={c.id} className="flex jb ic" style={{padding:"8px 0",borderBottom:`1px solid ${T.border}`}}>
            <div className="flex ic gap2"><Av name={c.name} color={T.teal}/><span className="fw7">{c.name}</span><span className="muted fs11">{c.phone}</span></div>
            <button className="btn btn-g btn-xs" onClick={()=>assignCns(c.id,"")}>הסר</button>
          </div>)}
          {unCns.length>0&&<><div className="divider"/><div className="fw7 fs12 mb3 muted">ללא קבוצה</div>
          {unCns.map(c=><div key={c.id} className="flex jb ic" style={{padding:"8px 0",borderBottom:`1px solid ${T.border}`}}>
            <div className="flex ic gap2"><Av name={c.name} color={T.teal}/><span>{c.name}</span><span className="muted fs11">{c.phone}</span></div>
            <button className="btn btn-t btn-xs" onClick={()=>assignCns(c.id,active.id)}>+ שייך</button>
          </div>)}</>}
        </>}
      </>}
    </Modal>
  </div>;
}

// ════════════════════════════════════════════════
// PAGE: TRIPS
// ════════════════════════════════════════════════
function TripsPage({data,setData,api,onRefresh}){
  const [modal,setModal]=useState(null);
  const [form,setForm]=useState({...ET});
  const [active,setActive]=useState(null);
  const [attTab,setAttTab]=useState("bus");
  const [stopIdx,setStopIdx]=useState(0);

  async function saveTrip(){
    try{
      const payload={...form,group_ids:form.groupIds||form.group_ids||[]};
      if(form.id&&data.trips.find(t=>t.id===form.id)){await api.updateTrip(form.id,payload);}
      else{await api.createTrip(payload);}
      await onRefresh();setModal(null);
    }catch(e){alert("שגיאה: "+e.message);}
  }
  async function delTrip(id){if(!window.confirm("למחוק טיול?"))return;
    try{await api.deleteTrip(id);await onRefresh();}catch(e){alert("שגיאה: "+e.message);}
  }

  const getGr=id=>data.groups.find(g=>g.id===id);
  const tripKids=t=>data.children.filter(c=>t.groupIds?.includes(c.groupId));
  const tripCns=t=>data.counselors.filter(c=>t.groupIds?.includes(c.groupId));

  function toggleGroup(gid){setForm(f=>({...f,groupIds:f.groupIds?.includes(gid)?f.groupIds.filter(x=>x!==gid):[...(f.groupIds||[]),gid]}));}

  function setAtt(tripId,entityId,stopKey,val){
    setData(d=>({...d,trips:d.trips.map(t=>t.id!==tripId?t:{...t,attendance:{...t.attendance,[stopKey]:{...t.attendance?.[stopKey],[entityId]:val}}})}));
    setActive(a=>a&&a.id===tripId?{...a,attendance:{...a.attendance,[stopKey]:{...a.attendance?.[stopKey],[entityId]:val}}}:a);
  }

  const stops=n=>{const arr=[];for(let i=0;i<n;i++)arr.push(i);return arr;};

  return <div className="page">
    <div className="ph">
      <div><h2>🚌 טיולים</h2><p>{data.trips.length} טיולים</p></div>
      <button className="btn btn-p btn-sm" onClick={()=>{setForm({...ET,id:uid(),groupIds:[],gear:{water:"",flashlight:false,swimsuit:false,clothes:false,prayer:false,extraMeal:false,other:""},stops:2,locations:[],attendance:{},counselorTrip:{}});setModal("add");}}>+ צור טיול</button>
    </div>
    {data.trips.length===0&&<div className="empty"><div className="ei">🚌</div><h4>אין טיולים עדיין</h4><p>לחץ "צור טיול" כדי להוסיף</p></div>}
    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:14}}>
      {data.trips.map(t=>{const kids=tripKids(t);const cns=tripCns(t);const attBus=t.attendance?.bus||{};const present=kids.filter(c=>attBus[c.id]===true).length;
        return <div key={t.id} className="card">
          <div className="card-b">
            <div className="flex jb ic mb3">
              <div><div style={{fontSize:15,fontWeight:800}}>🚌 {t.name}</div><div className="muted fs11 mt1">{fmtDate(t.date)}{t.returnDate&&` - ${fmtDate(t.returnDate)}`}</div></div>
              <div className="flex gap1"><button className="btn btn-g btn-xs" onClick={()=>{setForm({...t});setModal("edit");}}>✏️</button><button className="btn btn-d btn-xs" onClick={()=>delTrip(t.id)}>🗑️</button></div>
            </div>
            <div className="flex fw gap1 mb3">{(t.groupIds||[]).map(gid=>{const gr=getGr(gid);return gr?<span key={gid} className="gpill" style={{background:gr.color}}>{gr.name}</span>:null;})}</div>
            {t.locations?.length>0&&<div className="fs11 muted mb3">📍 {t.locations.join(" → ")}</div>}
            <div className="flex gap2">
              <div style={{background:T.purpleXL,borderRadius:8,padding:"8px 12px",flex:1,textAlign:"center"}}><div style={{fontSize:18,fontWeight:900,color:T.purple}}>{present}/{kids.length}</div><div className="fs11 muted">עלו לאוטובוס</div></div>
              <div style={{background:T.tealL,borderRadius:8,padding:"8px 12px",flex:1,textAlign:"center"}}><div style={{fontSize:18,fontWeight:900,color:T.teal}}>{cns.length}</div><div className="fs11 muted">מדריכים</div></div>
            </div>
            <button className="btn btn-p btn-sm w-full mt3" style={{width:"100%",justifyContent:"center"}} onClick={()=>{setActive(t);setAttTab("bus");setStopIdx(0);setModal("att");}}>📋 רישום נוכחות</button>
          </div>
        </div>;})}
    </div>

    {/* ADD/EDIT TRIP */}
    <Modal open={modal==="add"||modal==="edit"} onClose={()=>setModal(null)} title={modal==="add"?"➕ צור טיול":"✏️ עריכת טיול"} wide
      footer={<><button className="btn btn-g" onClick={()=>setModal(null)}>ביטול</button><button className="btn btn-p" onClick={saveTrip}>שמור</button></>}>
      <div className="fg">
        <Fld label="שם הטיול" sp><input value={form.name||""} onChange={e=>setForm(f=>({...f,name:e.target.value}))}/></Fld>
        <Fld label="תאריך יציאה"><input type="date" value={form.date||""} onChange={e=>setForm(f=>({...f,date:e.target.value}))}/></Fld>
        <Fld label="תאריך חזרה"><input type="date" value={form.returnDate||""} onChange={e=>setForm(f=>({...f,returnDate:e.target.value}))}/></Fld>
        <Fld label="מספר עצירות / אטרקציות"><input type="number" min={1} max={10} value={form.stops||2} onChange={e=>setForm(f=>({...f,stops:parseInt(e.target.value)||1}))}/></Fld>
        <Fld label="מקומות בילוי (מופרדים בפסיק)" sp><input placeholder="כנרת, מוזיאון, פארק..." value={(form.locations||[]).join(", ")} onChange={e=>setForm(f=>({...f,locations:e.target.value.split(",").map(x=>x.trim()).filter(Boolean)}))}/></Fld>
        <Fld label="קבוצות" sp>
          <div className="flex fw gap2 mt1">{data.groups.map(g=><span key={g.id} onClick={()=>toggleGroup(g.id)} style={{padding:"4px 12px",borderRadius:99,cursor:"pointer",border:`2px solid ${form.groupIds?.includes(g.id)?g.color:T.border}`,background:form.groupIds?.includes(g.id)?g.color+"22":"#F8FAFC",color:form.groupIds?.includes(g.id)?g.color:T.slate,fontWeight:700,fontSize:11}}>{g.name}</span>)}</div>
        </Fld>
        <Fld label="ציוד נדרש" sp>
          <div className="fw7 fs11 mb2">כמות מים (ליטר)</div>
          <input type="text" placeholder='כמו: 2 ליטר לפחות' value={form.gear?.water||""} onChange={e=>setForm(f=>({...f,gear:{...f.gear,water:e.target.value}}))} style={{marginBottom:8}}/>
          <div className="flex fw gap2">{[["flashlight","פנס 🔦"],["swimsuit","בגד ים 🩱"],["clothes","בגדים להחלפה 👕"],["prayer","סידור 📖"],["extraMeal","ארוחה נוספת 🥪"]].map(([k,l])=>(
            <label key={k} style={{display:"flex",alignItems:"center",gap:5,cursor:"pointer",fontSize:12,background:form.gear?.[k]?T.purpleXL:"#F8FAFC",padding:"5px 10px",borderRadius:8,border:`2px solid ${form.gear?.[k]?T.purple:T.border}`,fontWeight:600}}>
              <input type="checkbox" checked={!!form.gear?.[k]} onChange={e=>setForm(f=>({...f,gear:{...f.gear,[k]:e.target.checked}}))} style={{display:"none"}}/>{l}
            </label>))}</div>
          <input placeholder="אחר (טקסט חופשי)..." value={form.gear?.other||""} onChange={e=>setForm(f=>({...f,gear:{...f.gear,other:e.target.value}}))} style={{marginTop:8}}/>
        </Fld>
        <Fld label="הערות" sp><textarea value={form.notes||""} onChange={e=>setForm(f=>({...f,notes:e.target.value}))}/></Fld>
      </div>
    </Modal>

    {/* ATTENDANCE */}
    <Modal open={modal==="att"&&!!active} onClose={()=>setModal(null)} title={`📋 נוכחות - ${active?.name}`} wide>
      {active&&(()=>{
        const kids=tripKids(active);const cns=tripCns(active);
        const stopCount=active.stops||2;
        const stopLabels=["עלייה לאוטובוס",...Array.from({length:stopCount-1},(_, i)=>active.locations?.[i]||`עצירה ${i+1}`),"חזרה לאוטובוס"];
        return <>
          <div className="tabs" style={{overflowX:"auto",flexWrap:"nowrap"}}>
            {stopLabels.map((l,i)=><button key={i} className={`tab${attTab===`stop_${i}`?" active":""}`} onClick={()=>setAttTab(`stop_${i}`)} style={{whiteSpace:"nowrap"}}>{l}</button>)}
            <button className={`tab${attTab==="counselors"?" active":""}`} onClick={()=>setAttTab("counselors")}>👨‍🏫 מדריכים</button>
          </div>
          {attTab!=="counselors"&&(()=>{
            const stopKey=attTab;
            const attMap=active.attendance?.[stopKey]||{};
            return <div>
              <div className="flex jb ic mb3">
                <span className="fw7 fs12">חניכים ({kids.length})</span>
                <div className="flex gap2">
                  <button className="btn btn-t btn-xs" onClick={()=>kids.forEach(c=>setAtt(active.id,c.id,stopKey,true))}>✓ כולם נוכחים</button>
                  <button className="btn btn-g btn-xs" onClick={()=>kids.forEach(c=>setAtt(active.id,c.id,stopKey,false))}>✗ נקה</button>
                </div>
              </div>
              {data.groups.filter(g=>active.groupIds?.includes(g.id)).map(g=>{
                const gKids=kids.filter(c=>c.groupId===g.id);
                return <div key={g.id} className="mb3">
                  <div style={{fontSize:11,fontWeight:800,color:g.color,marginBottom:6,display:"flex",alignItems:"center",gap:6}}><span className="gpill" style={{background:g.color}}>{g.name}</span> {gKids.filter(c=>attMap[c.id]===true).length}/{gKids.length} נוכחים</div>
                  {gKids.map(c=>{const v=attMap[c.id];return(
                    <div key={c.id} className="flex jb ic" style={{padding:"7px 0",borderBottom:`1px solid ${T.border}`}}>
                      <div className="flex ic gap2"><Av name={`${c.name} ${c.lastName}`} color={g.color} size={28}/><span className="fw7 fs12">{c.name} {c.lastName}</span>{c.allergy?.includes("כן")&&<span className="chip chip-c" style={{fontSize:9}}>⚠️</span>}</div>
                      <div className="flex gap1">
                        <button className={`att-btn${v===true?" yes":""}`} onClick={()=>setAtt(active.id,c.id,stopKey,true)}>✓</button>
                        <button className={`att-btn${v===false?" no":""}`} onClick={()=>setAtt(active.id,c.id,stopKey,false)}>✗</button>
                      </div>
                    </div>);})}
                </div>;})}
            </div>;})()} 
          {attTab==="counselors"&&<div>
            {cns.map(c=>{const v=active.attendance?.["counselors"]?.[c.id];return(
              <div key={c.id} className="flex jb ic" style={{padding:"8px 0",borderBottom:`1px solid ${T.border}`}}>
                <div className="flex ic gap2"><Av name={c.name} color={T.teal} size={28}/><span className="fw7 fs12">{c.name}</span><span className="muted fs11">{c.phone}</span></div>
                <div className="flex gap1">
                  <button className={`att-btn${v===true?" yes":""}`} onClick={()=>setAtt(active.id,c.id,"counselors",true)}>✓</button>
                  <button className={`att-btn${v===false?" no":""}`} onClick={()=>setAtt(active.id,c.id,"counselors",false)}>✗</button>
                </div>
              </div>);})}
          </div>}
        </>;
      })()}
    </Modal>
  </div>;
}

// ════════════════════════════════════════════════
// PAGE: SCORES
// ════════════════════════════════════════════════
function ScoresPage({data,setData,api,onRefresh}){
  const [modal,setModal]=useState(null);
  const [form,setForm]=useState({...ETASK});
  const [scoreModal,setScoreModal]=useState(null);
  const [scoreForm,setScoreForm]=useState({entityId:"",entityType:"child",taskId:"",value:10,note:"",date:today()});
  const [tab,setTab]=useState("board");

  async function saveTask(){
    try{
      if(form.id&&(data.tasks||[]).find(t=>t.id===form.id)){await api.updateTask(form.id,form);}
      else{await api.createTask(form);}
      await onRefresh();setModal(null);
    }catch(e){alert("שגיאה: "+e.message);}
  }
  async function delTask(id){if(!window.confirm("למחוק משימה?"))return;
    try{await api.deleteTask(id);await onRefresh();}catch(e){alert("שגיאה: "+e.message);}
  }
  async function saveScore(){
    try{await api.addScore({...scoreForm,value:parseInt(scoreForm.value)});await onRefresh();setScoreModal(null);}
    catch(e){alert("שגיאה: "+e.message);}
  }

  const tasks=data.tasks||[];
  const scores=data.scores||[];

  // Group scores
  const groupScore=gid=>scores.filter(s=>s.entityType==="group"&&s.entityId===gid).reduce((a,s)=>a+Number(s.value),0);
  const childScore=cid=>scores.filter(s=>s.entityType==="child"&&s.entityId===cid).reduce((a,s)=>a+Number(s.value),0);
  const maxGroupScore=Math.max(1,...data.groups.map(g=>groupScore(g.id)));

  return <div className="page">
    <div className="ph">
      <div><h2>🏆 לוח ניקוד</h2><p>ניקוד קבוצות וחניכים</p></div>
      <div className="ph-actions">
        <button className="btn btn-g btn-sm" onClick={()=>{setForm({...ETASK,id:uid()});setModal("task");}}>+ צור משימה</button>
        <button className="btn btn-p btn-sm" onClick={()=>{setScoreForm({entityId:data.groups[0]?.id||"",entityType:"group",taskId:"",value:10,note:"",date:today()});setScoreModal("score");}}>+ הענק ניקוד</button>
      </div>
    </div>
    <div className="tabs">{[["board","לוח קבוצות"],["children","ניקוד חניכים"],["tasks","משימות"]].map(([v,l])=><button key={v} className={`tab${tab===v?" active":""}`} onClick={()=>setTab(v)}>{l}</button>)}</div>

    {tab==="board"&&<div>
      {data.groups.length===0&&<div className="empty"><div className="ei">🏆</div><h4>אין קבוצות</h4><p>צור קבוצות תחילה</p></div>}
      {[...data.groups].sort((a,b)=>groupScore(b.id)-groupScore(a.id)).map((g,i)=>{const sc=groupScore(g.id);const pct=Math.round(sc/maxGroupScore*100);return(
        <div key={g.id} className="card mb3">
          <div className="card-b">
            <div className="flex jb ic mb2">
              <div className="flex ic gap2">
                <div style={{fontSize:20,fontWeight:900,color:T.muted,width:28}}>#{i+1}</div>
                <span className="gpill" style={{background:g.color,fontSize:12,padding:"4px 12px"}}>{g.name}</span>
                <span className="muted fs11">{data.children.filter(c=>c.groupId===g.id).length} חניכים</span>
              </div>
              <div style={{fontSize:26,fontWeight:900,color:g.color}}>{sc} <span className="fs12 muted fw7">נק'</span></div>
            </div>
            <div className="score-bar"><div className="score-fill" style={{width:`${pct}%`,background:g.color}}/></div>
          </div>
        </div>);})}
    </div>}

    {tab==="children"&&<div className="card"><div className="tw"><table>
      <thead><tr><th>חניך</th><th>קבוצה</th><th>ניקוד</th><th>מספר פעמים</th></tr></thead>
      <tbody>
        {[...data.children].sort((a,b)=>childScore(b.id)-childScore(a.id)).map(c=>{const gr=data.groups.find(g=>g.id===c.groupId);const sc=childScore(c.id);const cnt=scores.filter(s=>s.entityType==="child"&&s.entityId===c.id).length;return(
          <tr key={c.id}>
            <td><div className="flex ic gap2"><Av name={`${c.name} ${c.lastName}`}/><span className="fw7">{c.name} {c.lastName}</span></div></td>
            <td>{gr?<span className="gpill" style={{background:gr.color}}>{gr.name}</span>:"-"}</td>
            <td><span style={{fontSize:16,fontWeight:900,color:T.purple}}>{sc}</span> <span className="muted fs11">נק'</span></td>
            <td className="muted fs11">{cnt} הענקות</td>
          </tr>);})}
      </tbody>
    </table></div></div>}

    {tab==="tasks"&&<div>
      {tasks.length===0&&<div className="empty"><div className="ei">📋</div><h4>אין משימות</h4><p>לחץ "צור משימה" להוספה</p></div>}
      <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(240px,1fr))",gap:12}}>
        {tasks.map(t=>(
          <div key={t.id} className="card">
            <div className="card-b">
              <div className="flex jb ic mb2">
                <span className="fw8 fs13">{t.title}</span>
                <div className="flex gap1"><button className="btn btn-g btn-xs" onClick={()=>{setForm({...t});setModal("task");}}>✏️</button><button className="btn btn-d btn-xs" onClick={()=>delTask(t.id)}>🗑️</button></div>
              </div>
              <div className="flex gap2 fw">
                <span className="chip chip-p">⭐ {t.points} נק'</span>
                <span className={`chip ${t.type==="group"?"chip-t":"chip-s"}`}>{t.type==="group"?"⛺ קבוצה":"👦 ילד"}</span>
              </div>
              {t.notes&&<p className="muted fs11 mt2">{t.notes}</p>}
              <button className="btn btn-p btn-xs mt3" onClick={()=>{setScoreForm({entityId:t.type==="group"?(data.groups[0]?.id||""):(data.children[0]?.id||""),entityType:t.type,taskId:t.id,value:t.points,note:"",date:today()});setScoreModal("score");}}>הענק ניקוד</button>
            </div>
          </div>))}
      </div>
    </div>}

    <Modal open={modal==="task"} onClose={()=>setModal(null)} title="📋 משימה"
      footer={<><button className="btn btn-g" onClick={()=>setModal(null)}>ביטול</button><button className="btn btn-p" onClick={saveTask}>שמור</button></>}>
      <div className="fg s1">
        <Fld label="שם המשימה"><input value={form.title||""} onChange={e=>setForm(f=>({...f,title:e.target.value}))}/></Fld>
        <Fld label="ניקוד"><input type="number" min={1} value={form.points||10} onChange={e=>setForm(f=>({...f,points:parseInt(e.target.value)||10}))}/></Fld>
        <Fld label="שייך ל">
          <select value={form.type} onChange={e=>setForm(f=>({...f,type:e.target.value}))}>
            <option value="group">⛺ קבוצה</option><option value="child">👦 ילד</option>
          </select>
        </Fld>
        <Fld label="הערות"><textarea value={form.notes||""} onChange={e=>setForm(f=>({...f,notes:e.target.value}))}/></Fld>
      </div>
    </Modal>

    <Modal open={!!scoreModal} onClose={()=>setScoreModal(null)} title="⭐ הענק ניקוד"
      footer={<><button className="btn btn-g" onClick={()=>setScoreModal(null)}>ביטול</button><button className="btn btn-p" onClick={saveScore}>הענק</button></>}>
      <div className="fg s1">
        <Fld label="הענק ל">
          <select value={scoreForm.entityType} onChange={e=>setScoreForm(f=>({...f,entityType:e.target.value,entityId:""}))}>
            <option value="group">⛺ קבוצה</option><option value="child">👦 ילד</option>
          </select>
        </Fld>
        <Fld label={scoreForm.entityType==="group"?"קבוצה":"חניך"}>
          <select value={scoreForm.entityId} onChange={e=>setScoreForm(f=>({...f,entityId:e.target.value}))}>
            <option value="">בחר...</option>
            {scoreForm.entityType==="group"?data.groups.map(g=><option key={g.id} value={g.id}>{g.name}</option>):data.children.map(c=><option key={c.id} value={c.id}>{c.name} {c.lastName}</option>)}
          </select>
        </Fld>
        {tasks.filter(t=>t.type===scoreForm.entityType).length>0&&<Fld label="משימה (אופציונלי)">
          <select value={scoreForm.taskId} onChange={e=>{const t=tasks.find(x=>x.id===e.target.value);setScoreForm(f=>({...f,taskId:e.target.value,value:t?t.points:f.value}));}}>
            <option value="">ללא משימה</option>
            {tasks.filter(t=>t.type===scoreForm.entityType).map(t=><option key={t.id} value={t.id}>{t.title} ({t.points} נק')</option>)}
          </select>
        </Fld>}
        <Fld label={`ניקוד: ${scoreForm.value}`}><input type="range" min={1} max={100} value={scoreForm.value} onChange={e=>setScoreForm(f=>({...f,value:parseInt(e.target.value)}))} style={{accentColor:T.purple}}/></Fld>
        <Fld label="הערה"><input value={scoreForm.note} onChange={e=>setScoreForm(f=>({...f,note:e.target.value}))}/></Fld>
      </div>
    </Modal>
  </div>;
}

// ════════════════════════════════════════════════
// PAGE: ATTENDANCE (DAILY)
// ════════════════════════════════════════════════
function AttendancePage({data,setData,api,onRefresh,user}){
  const [selDate,setSelDate]=useState(today());
  const [modal,setModal]=useState(null);
  const [absChild,setAbsChild]=useState(null);

  const dayAtt=data.attendance?.[selDate]||{};

  // Trips on selected date
  const tripsToday=(data.trips||[]).filter(t=>t.date===selDate);

  async function setAtt(childId,val){
    try{
      await api.setAttendance({child_id:childId,date:selDate,present:val});
      setData(d=>({...d,attendance:{...d.attendance,[selDate]:{...(d.attendance?.[selDate]||{}),[childId]:val}}}));
    }catch(e){alert("שגיאה: "+e.message);}
  }
  function markAll(val){data.children.forEach(c=>setAtt(c.id,val));}

  const present=data.children.filter(c=>dayAtt[c.id]===true).length;
  const absent=data.children.filter(c=>dayAtt[c.id]===false).length;
  const notMarked=data.children.filter(c=>dayAtt[c.id]===undefined).length;

  const getGr=id=>data.groups.find(g=>g.id===id);

  // Simulate absence alert message
  function getAbsMsg(c){
    const campTime=data.settings?.campStartTime||"08:30";
    return `שלום, זוהי הודעה אוטומטית מקייטנת גן ישראל חדרה.\n${c.name} ${c.lastName} לא הגיע/ה לקייטנה עד לשעה ${campTime}.\nלפרטים נוספים צרו קשר עם הצוות.\nתודה.`;
  }

  return <div className="page">
    <div className="ph">
      <div><h2>📅 נוכחות יומית</h2><p>רישום נוכחות חניכים</p></div>
      <div className="ph-actions">
        <input type="date" value={selDate} onChange={e=>setSelDate(e.target.value)} style={{padding:"7px 12px",border:`2px solid ${T.border}`,borderRadius:9,fontFamily:"Heebo",fontSize:12,outline:"none"}}/>
        <button className="btn btn-t btn-sm" onClick={()=>markAll(true)}>✓ כולם נוכחים</button>
        <button className="btn btn-g btn-sm" onClick={()=>markAll(false)}>✗ כולם נעדרים</button>
      </div>
    </div>
    <div className="stats">
      {[{i:"✅",v:present,l:"נוכחים",c:T.teal},{i:"❌",v:absent,l:"נעדרים",c:T.coral},{i:"❓",v:notMarked,l:"טרם סומן",c:T.amber},{i:"👦",v:data.children.length,l:"סה\"כ",c:T.purple}]
        .map(s=><div key={s.l} className="sc"><div className="i">{s.i}</div><div className="v" style={{color:s.c}}>{s.v}</div><div className="l">{s.l}</div></div>)}
    </div>

    {tripsToday.length>0&&<div className="alert alert-t mb4" style={{display:"flex",alignItems:"center",justifyContent:"space-between",gap:12}}>
      <span>🚌 <strong>יש {tripsToday.length} טיול{tripsToday.length>1?"ים":""} היום</strong> ({tripsToday.map(t=>t.name).join(", ")}) - סימון נוכחות מסונכרן אוטומטית</span>
    </div>}

    {absent>0&&<div className="alert alert-a mb4">
      ⚠️ {absent} חניכים נעדרים היום - <button className="btn btn-a btn-xs" style={{marginRight:8}} onClick={()=>setModal("absences")}>📢 הצג הודעות להורים</button>
    </div>}

    <div className="card"><div className="tw"><table>
      <thead><tr><th>חניך</th><th>כיתה</th><th>קבוצה</th><th>טלפון</th><th>נוכחות</th><th>הודעה להורה</th></tr></thead>
      <tbody>
        {data.groups.length===0&&data.children.map(c=>{const v=dayAtt[c.id];return <tr key={c.id}>
            <td><div className="flex ic gap2"><Av name={`${c.name} ${c.lastName}`} size={28}/><span className="fw7 fs12">{c.name} {c.lastName}</span></div></td>
            <td className="fs11">{c.grade}</td><td className="muted fs11">ללא קבוצה</td>
            <td className="fs11">{c.fatherPhone||c.motherPhone||"-"}</td>
            <td><div className="flex gap1">
              <button className={`att-btn${v===true?" yes":""}`} onClick={()=>setAtt(c.id,true)}>✓</button>
              <button className={`att-btn${v===false?" no":""}`} onClick={()=>setAtt(c.id,false)}>✗</button>
            </div></td>
            <td>{v===false?<button className="btn btn-a btn-xs" onClick={()=>{setAbsChild(c);setModal("msg");}}>📱 הודעה</button>:"-"}</td>
          </tr>;})}
        {data.groups.map(g=>{const kids=data.children.filter(c=>c.groupId===g.id);if(!kids.length)return null;return(<>
          <tr key={`gh_${g.id}`}><td colSpan={6} style={{background:g.color+"11",padding:"6px 12px"}}><span className="gpill" style={{background:g.color,fontSize:10}}>{g.name}</span><span className="muted fs11" style={{marginRight:8}}>{kids.filter(c=>dayAtt[c.id]===true).length}/{kids.length} נוכחים</span></td></tr>
          {kids.map(c=>{const v=dayAtt[c.id];return <tr key={c.id}>
            <td><div className="flex ic gap2"><Av name={`${c.name} ${c.lastName}`} color={g.color} size={28}/><span className="fw7 fs12">{c.name} {c.lastName}</span></div></td>
            <td className="fs11">{c.grade}</td>
            <td><span className="gpill" style={{background:g.color,fontSize:10}}>{g.name}</span></td>
            <td className="fs11">{c.fatherPhone||c.motherPhone||"-"}</td>
            <td><div className="flex gap1">
              <button className={`att-btn${v===true?" yes":""}`} onClick={()=>setAtt(c.id,true)}>✓</button>
              <button className={`att-btn${v===false?" no":""}`} onClick={()=>setAtt(c.id,false)}>✗</button>
            </div></td>
            <td>{v===false?<button className="btn btn-a btn-xs" onClick={()=>{setAbsChild(c);setModal("msg");}}>📱 הודעה</button>:"-"}</td>
          </tr>;})}
        </>);})}
        {data.children.filter(c=>!c.groupId).map(c=>{const v=dayAtt[c.id];return <tr key={c.id}>
          <td><div className="flex ic gap2"><Av name={`${c.name} ${c.lastName}`} size={28}/><span className="fw7 fs12">{c.name} {c.lastName}</span></div></td>
          <td className="fs11">{c.grade}</td><td className="muted fs11">ללא קבוצה</td>
          <td className="fs11">{c.fatherPhone||c.motherPhone||"-"}</td>
          <td><div className="flex gap1">
            <button className={`att-btn${v===true?" yes":""}`} onClick={()=>setAtt(c.id,true)}>✓</button>
            <button className={`att-btn${v===false?" no":""}`} onClick={()=>setAtt(c.id,false)}>✗</button>
          </div></td>
          <td>{v===false?<button className="btn btn-a btn-xs" onClick={()=>{setAbsChild(c);setModal("msg");}}>📱 הודעה</button>:"-"}</td>
        </tr>;})}
      </tbody>
    </table></div></div>

    {/* ABSENCE MSG MODAL */}
    <Modal open={modal==="msg"&&!!absChild} onClose={()=>setModal(null)} title={`📱 הודעת היעדרות - ${absChild?.name}`} narrow>
      {absChild&&<>
        <div style={{background:T.slateL,borderRadius:10,padding:14,fontSize:12,lineHeight:1.8,whiteSpace:"pre-line"}}>{getAbsMsg(absChild)}</div>
        <div className="flex gap2 mt3">
          {absChild.fatherPhone&&<a href={`https://wa.me/972${absChild.fatherPhone.replace(/\D/g,"").replace(/^0/,"")}`} target="_blank" rel="noreferrer" className="btn btn-t btn-sm" style={{flex:1,justifyContent:"center",textDecoration:"none"}}>📱 WhatsApp אבא</a>}
          {absChild.motherPhone&&<a href={`https://wa.me/972${absChild.motherPhone.replace(/\D/g,"").replace(/^0/,"")}`} target="_blank" rel="noreferrer" className="btn btn-t btn-sm" style={{flex:1,justifyContent:"center",textDecoration:"none"}}>📱 WhatsApp אמא</a>}
        </div>
        <button className="btn btn-g btn-sm mt2" style={{width:"100%",justifyContent:"center"}} onClick={()=>{navigator.clipboard?.writeText(getAbsMsg(absChild)).then(()=>alert("הועתק!"));}}>📋 העתק הודעה</button>
      </>}
    </Modal>

    {/* ALL ABSENCES */}
    <Modal open={modal==="absences"} onClose={()=>setModal(null)} title="📢 נעדרים היום" wide>
      {data.children.filter(c=>dayAtt[c.id]===false).map(c=>(
        <div key={c.id} className="flex jb ic" style={{padding:"10px 0",borderBottom:`1px solid ${T.border}`}}>
          <div className="flex ic gap2"><Av name={`${c.name} ${c.lastName}`}/><div><div className="fw7 fs12">{c.name} {c.lastName}</div><div className="muted fs11">{c.fatherPhone} | {c.motherPhone}</div></div></div>
          <div className="flex gap1">
            {c.fatherPhone&&<a href={`https://wa.me/972${c.fatherPhone.replace(/\D/g,"").replace(/^0/,"")}`} target="_blank" rel="noreferrer" className="btn btn-t btn-xs" style={{textDecoration:"none"}}>WA אבא</a>}
            {c.motherPhone&&<a href={`https://wa.me/972${c.motherPhone.replace(/\D/g,"").replace(/^0/,"")}`} target="_blank" rel="noreferrer" className="btn btn-t btn-xs" style={{textDecoration:"none"}}>WA אמא</a>}
          </div>
        </div>))}
    </Modal>
  </div>;
}

// ════════════════════════════════════════════════
// PAGE: MESSAGES
// ════════════════════════════════════════════════
function MessagesPage({data}){
  const [msg,setMsg]=useState("");
  const [target,setTarget]=useState("all");
  const [channel,setChannel]=useState("whatsapp");

  const VARS=[
    {k:"{{שם_ילד}}",l:"שם ילד"},
    {k:"{{שם_קבוצה}}",l:"שם קבוצה"},
    {k:"{{שם_מדריך}}",l:"שם מדריך ראשי"},
    {k:"{{תאריך_טיול}}",l:"תאריך טיול הבא"},
    {k:"{{שם_טיול}}",l:"שם טיול הבא"},
  ];

  function insertVar(v){setMsg(m=>m+v);}
  function buildPhone(p){return`972${p.replace(/\D/g,"").replace(/^0/,"")}`;}

  const recipients=data.children.filter(c=>{
    if(target==="all")return true;
    return c.groupId===target;
  });

  function preview(c){
    const gr=data.groups.find(g=>g.id===c.groupId);
    const cns=gr?data.counselors.find(cs=>cs.groupId===gr.id):null;
    const trip=data.trips?.[0];
    return msg.replace("{{שם_ילד}}",c.name).replace("{{שם_קבוצה}}",gr?.name||"").replace("{{שם_מדריך}}",cns?.name||"").replace("{{תאריך_טיול}}",trip?fmtDate(trip.date):"").replace("{{שם_טיול}}",trip?.name||"");
  }

  return <div className="page">
    <div className="ph"><div><h2>📢 הודעות</h2><p>שליחה להורים</p></div></div>
    <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16}}>
      <div>
        <div className="card mb4">
          <div className="card-h"><h3>✍️ כתיבת הודעה</h3></div>
          <div className="card-b">
            <div className="field mb3"><label>ערוץ שליחה</label>
              <select value={channel} onChange={e=>setChannel(e.target.value)}>
                <option value="whatsapp">📱 WhatsApp</option>
                <option value="sms">💬 SMS</option>
                <option value="email">📧 אימייל</option>
              </select>
            </div>
            <div className="field mb3"><label>שלח ל</label>
              <select value={target} onChange={e=>setTarget(e.target.value)}>
                <option value="all">כל ההורים</option>
                {data.groups.map(g=><option key={g.id} value={g.id}>קבוצת {g.name}</option>)}
              </select>
            </div>
            <div className="field mb3"><label>תוכן ההודעה</label>
              <textarea value={msg} onChange={e=>setMsg(e.target.value)} style={{minHeight:120}} placeholder="כתוב הודעה כאן..."/>
            </div>
            <div className="fw7 fs11 mb2">הכנס משתנה:</div>
            <div className="flex fw gap1 mb3">{VARS.map(v=><button key={v.k} className="btn btn-g btn-xs" onClick={()=>insertVar(v.k)}>{v.l}</button>)}</div>
            <div className="muted fs11">* ההודעה תישלח לכל ההורים הנבחרים עם פרטים אישיים</div>
          </div>
        </div>
      </div>
      <div>
        <div className="card">
          <div className="card-h"><h3>👁️ תצוגה מקדימה ({recipients.length} הורים)</h3></div>
          <div className="card-b" style={{maxHeight:440,overflowY:"auto"}}>
            {recipients.slice(0,5).map(c=>{const p=preview(c);const phone=c.fatherPhone||c.motherPhone;return(
              <div key={c.id} style={{background:T.slateL,borderRadius:10,padding:12,marginBottom:10}}>
                <div className="flex jb ic mb2"><span className="fw7 fs12">{c.name} {c.lastName}</span><span className="muted fs11">{phone}</span></div>
                <div style={{fontSize:11,lineHeight:1.7,whiteSpace:"pre-line",background:"#fff",borderRadius:8,padding:10}}>{p||"(הודעה ריקה)"}</div>
                {channel==="whatsapp"&&phone&&<a href={`https://wa.me/${buildPhone(phone)}?text=${encodeURIComponent(p)}`} target="_blank" rel="noreferrer" className="btn btn-t btn-xs mt2" style={{textDecoration:"none"}}>📱 שלח WhatsApp</a>}
              </div>);})}
            {recipients.length>5&&<div className="muted fs11 mt2" style={{textAlign:"center"}}>+ עוד {recipients.length-5} הורים...</div>}
          </div>
        </div>
      </div>
    </div>
  </div>;
}

// ════════════════════════════════════════════════
// PAGE: SETTINGS
// ════════════════════════════════════════════════
const DEFAULT_THEME={primary:"#7C3AED",secondary:"#0D9488",accent:"#F59E0B",danger:"#F43F5E",sidebar:"#0F172A"};
const EMPTY_ADMIN={id:"",name:"",email:"",password:"",role:"viewer",active:true};
const ADMIN_ROLES={admin:"מנהל מלא",editor:"עורך",viewer:"צפייה בלבד"};

function SettingsPage({data,setData,onThemeChange}){
  const s=data.settings||{};
  const [stab,setStab]=useState("general");
  const [adminForm,setAdminForm]=useState({...EMPTY_ADMIN});
  const [adminModal,setAdminModal]=useState(null);
  const [showCode,setShowCode]=useState(false);
  const [restoreCode,setRestoreCode]=useState("");
  const [restoreMsg,setRestoreMsg]=useState("");
  const [theme,setTheme]=useState(s.theme||DEFAULT_THEME);
  const logoRef=useRef();

  async function upd(k,v){
    setData(d=>({...d,settings:{...d.settings,[k]:v}}));
    try{await api.saveSettings({[k]:v});}catch(e){console.error(e);}
  }

  function handleLogo(e){
    const file=e.target.files[0];if(!file)return;
    const reader=new FileReader();
    reader.onload=ev=>upd("logo",ev.target.result);
    reader.readAsDataURL(file);
  }

  function saveTheme(){
    upd("theme",theme);
    onThemeChange(theme);
  }

  function resetTheme(){
    setTheme(DEFAULT_THEME);
    upd("theme",DEFAULT_THEME);
    onThemeChange(DEFAULT_THEME);
  }

  // Backup code = base64 of entire data
  function generateCode(){
    try{return btoa(unescape(encodeURIComponent(JSON.stringify(data))));}catch{return "";}
  }

  function doRestore(){
    try{
      const decoded=JSON.parse(decodeURIComponent(escape(atob(restoreCode.trim()))));
      if(!decoded.children)throw new Error("invalid");
      setData(decoded);
      setRestoreMsg("✅ שוחזר בהצלחה!");
    }catch{setRestoreMsg("❌ קוד שחזור לא תקין");}
  }

  function saveAdmin(){
    const admins=s.admins||[];
    const ex=admins.find(a=>a.id===adminForm.id);
    const newList=ex?admins.map(a=>a.id===adminForm.id?adminForm:a):[...admins,{...adminForm,id:uid()}];
    upd("admins",newList);
    setAdminModal(null);
  }
  function delAdmin(id){if(!window.confirm("למחוק מנהל?"))return;upd("admins",(s.admins||[]).filter(a=>a.id!==id));}

  const SRow=({label,hint,children,border=true})=>(
    <div className="flex jb ic" style={{padding:"14px 0",borderBottom:border?`1px solid ${T.border}`:"none",gap:16}}>
      <div style={{flex:1}}><div className="fw7 fs12">{label}</div>{hint&&<div className="muted fs11 mt1">{hint}</div>}</div>
      <div style={{flexShrink:0}}>{children}</div>
    </div>
  );

  return <div className="page">
    <div className="ph"><div><h2>⚙️ הגדרות מערכת</h2></div></div>
    <div className="tabs">{[["general","כללי"],["appearance","עיצוב"],["admins","מנהלים"],["backup","שחזור"]].map(([v,l])=><button key={v} className={`tab${stab===v?" active":""}`} onClick={()=>setStab(v)}>{l}</button>)}</div>

    {/* ── GENERAL ── */}
    {stab==="general"&&<div style={{maxWidth:560}}>
      <div className="card mb4">
        <div className="card-h"><h3>🏕️ פרטי הקייטנה</h3></div>
        <div className="card-b">
          <SRow label="שם הקייטנה">
            <input value={s.campName||""} onChange={e=>upd("campName",e.target.value)} style={{padding:"7px 10px",border:`2px solid ${T.border}`,borderRadius:8,fontFamily:"Heebo",fontSize:12,outline:"none",width:200,textAlign:"right"}}/>
          </SRow>
          <SRow label="לוגו הקייטנה" hint="PNG / JPG / SVG - יוצג בסרגל הצד">
            <div className="flex ic gap2">
              {s.logo&&<img src={s.logo} alt="logo" style={{height:36,borderRadius:6,objectFit:"contain",background:T.slateL,padding:3}}/>}
              <button className="btn btn-g btn-sm" onClick={()=>logoRef.current.click()}>📷 העלה לוגו</button>
              {s.logo&&<button className="btn btn-d btn-xs" onClick={()=>upd("logo",null)}>✕</button>}
              <input ref={logoRef} type="file" accept="image/*" style={{display:"none"}} onChange={handleLogo}/>
            </div>
          </SRow>
          <SRow label="תאריך תחילת הקייטנה">
            <input type="date" value={s.campStart||""} onChange={e=>upd("campStart",e.target.value)} style={{padding:"7px 10px",border:`2px solid ${T.border}`,borderRadius:8,fontFamily:"Heebo",fontSize:12,outline:"none"}}/>
          </SRow>
          <SRow label="תאריך סיום הקייטנה" border={false}>
            <input type="date" value={s.campEnd||""} onChange={e=>upd("campEnd",e.target.value)} style={{padding:"7px 10px",border:`2px solid ${T.border}`,borderRadius:8,fontFamily:"Heebo",fontSize:12,outline:"none"}}/>
          </SRow>
        </div>
      </div>
      <div className="card">
        <div className="card-h"><h3>🔔 הגדרות הודעות</h3></div>
        <div className="card-b">
          <SRow label="שעת תחילת הקייטנה" hint="הודעות היעדרות יישלחו לאחר שעה זו">
            <input type="time" value={s.campStartTime||"08:30"} onChange={e=>upd("campStartTime",e.target.value)} style={{padding:"7px 10px",border:`2px solid ${T.border}`,borderRadius:8,fontFamily:"Heebo",fontSize:12,outline:"none"}}/>
          </SRow>
          <SRow label="הודעת היעדרות אוטומטית" hint="שלח הודעה להורים כשילד לא הגיע">
            <Toggle on={s.autoAbsenceAlert!==false} onToggle={()=>upd("autoAbsenceAlert",!(s.autoAbsenceAlert!==false))}/>
          </SRow>
          <SRow label="אי שליחה בשבת" hint="לא ישלחו הודעות אוטומטיות בשבת (שישי אחצ - מוצש)" border={false}>
            <Toggle on={!!s.noShabat} onToggle={()=>upd("noShabat",!s.noShabat)}/>
          </SRow>
        </div>
      </div>
    </div>}

    {/* ── APPEARANCE ── */}
    {stab==="appearance"&&<div style={{maxWidth:620}}>
      <div className="card mb4">
        <div className="card-h"><h3>🎨 צבעי המערכת</h3></div>
        <div className="card-b">
          <div className="fg" style={{gap:20}}>
            {[
              {k:"primary",l:"צבע ראשי (כפתורים, active)"},
              {k:"secondary",l:"צבע משני (ירוק-כחול)"},
              {k:"accent",l:"צבע דגש (ניקוד, אחים)"},
              {k:"danger",l:"צבע אדום (אלרגיה, מחיקה)"},
              {k:"sidebar",l:"צבע סרגל צד"},
            ].map(({k,l})=>(
              <div key={k} className="field">
                <label>{l}</label>
                <div className="flex ic gap2">
                  <input type="color" value={theme[k]||"#000000"} onChange={e=>setTheme(t=>({...t,[k]:e.target.value}))}
                    style={{width:44,height:36,border:`2px solid ${T.border}`,borderRadius:8,cursor:"pointer",padding:2}}/>
                  <input value={theme[k]||""} onChange={e=>setTheme(t=>({...t,[k]:e.target.value}))}
                    style={{padding:"7px 10px",border:`2px solid ${T.border}`,borderRadius:8,fontFamily:"monospace",fontSize:12,outline:"none",width:100}}/>
                  <div style={{width:28,height:28,borderRadius:8,background:theme[k],border:`1px solid ${T.border}`}}/>
                </div>
              </div>
            ))}
          </div>
          <div className="flex gap2 mt4">
            <button className="btn btn-p btn-sm" onClick={saveTheme}>✓ החל עיצוב</button>
            <button className="btn btn-g btn-sm" onClick={resetTheme}>↺ אפס לברירת מחדל</button>
          </div>
          <div className="muted fs11 mt3">* שינויי צבע ייכנסו לתוקף מיד ויישמרו לכל הפעלה הבאה</div>
        </div>
      </div>
      {/* Preview */}
      <div className="card">
        <div className="card-h"><h3>👁️ תצוגה מקדימה</h3></div>
        <div className="card-b">
          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:12}}>
            <button style={{background:theme.primary,color:"#fff",border:"none",borderRadius:9,padding:"8px 16px",fontFamily:"Heebo",fontSize:12,fontWeight:700,cursor:"default"}}>כפתור ראשי</button>
            <button style={{background:theme.secondary,color:"#fff",border:"none",borderRadius:9,padding:"8px 16px",fontFamily:"Heebo",fontSize:12,fontWeight:700,cursor:"default"}}>כפתור משני</button>
            <button style={{background:theme.accent,color:"#fff",border:"none",borderRadius:9,padding:"8px 16px",fontFamily:"Heebo",fontSize:12,fontWeight:700,cursor:"default"}}>דגש</button>
            <button style={{background:theme.danger,color:"#fff",border:"none",borderRadius:9,padding:"8px 16px",fontFamily:"Heebo",fontSize:12,fontWeight:700,cursor:"default"}}>מחיקה</button>
          </div>
          <div style={{display:"flex",gap:6}}>
            <span style={{background:theme.primary+"22",color:theme.primary,padding:"4px 10px",borderRadius:99,fontSize:11,fontWeight:700}}>תג ראשי</span>
            <span style={{background:theme.secondary+"22",color:theme.secondary,padding:"4px 10px",borderRadius:99,fontSize:11,fontWeight:700}}>תג משני</span>
            <span style={{background:theme.accent+"22",color:theme.accent,padding:"4px 10px",borderRadius:99,fontSize:11,fontWeight:700}}>תג דגש</span>
          </div>
          <div style={{marginTop:12,background:theme.sidebar,borderRadius:10,padding:"10px 14px",color:"rgba(255,255,255,.7)",fontSize:12}}>
            ← תצוגת סרגל צד
          </div>
        </div>
      </div>
    </div>}

    {/* ── ADMINS ── */}
    {stab==="admins"&&<div style={{maxWidth:640}}>
      <div className="card">
        <div className="card-h">
          <h3>👤 ניהול מנהלים והרשאות</h3>
          <button className="btn btn-p btn-sm" onClick={()=>{setAdminForm({...EMPTY_ADMIN,id:uid()});setAdminModal("add");}}>+ הוסף מנהל</button>
        </div>
        <div className="tw">
          <table>
            <thead><tr><th>שם</th><th>אימייל</th><th>הרשאה</th><th>סטטוס</th><th></th></tr></thead>
            <tbody>
              {(s.admins||[]).length===0&&<tr><td colSpan={5}><div className="empty"><div className="ei">👤</div><h4>אין מנהלים מוגדרים</h4><p>הוסף מנהל כדי לנהל גישות</p></div></td></tr>}
              {(s.admins||[]).map(a=>(
                <tr key={a.id}>
                  <td><div className="flex ic gap2"><Av name={a.name} size={28}/><span className="fw7">{a.name}</span></div></td>
                  <td className="fs11 muted">{a.email}</td>
                  <td><span className={`chip ${a.role==="admin"?"chip-p":a.role==="editor"?"chip-t":"chip-s"}`}>{ADMIN_ROLES[a.role]||a.role}</span></td>
                  <td><span className={`chip ${a.active?"chip-t":"chip-s"}`}>{a.active?"פעיל":"מושבת"}</span></td>
                  <td><div className="tda">
                    <button className="btn btn-g btn-xs" onClick={()=>{setAdminForm({...a});setAdminModal("edit");}}>✏️</button>
                    <button className="btn btn-g btn-xs" onClick={()=>upd("admins",(s.admins||[]).map(x=>x.id===a.id?{...x,active:!x.active}:x))}>{a.active?"🔒":"🔓"}</button>
                    <button className="btn btn-d btn-xs" onClick={()=>delAdmin(a.id)}>🗑️</button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>}

    {/* ── BACKUP ── */}
    {stab==="backup"&&<div style={{maxWidth:560}}>
      <div className="card mb4">
        <div className="card-h"><h3>💾 גיבוי נתונים</h3></div>
        <div className="card-b">
          <p style={{fontSize:13,color:T.slate,lineHeight:1.7,marginBottom:16}}>
            קוד הגיבוי מכיל את <strong>כל נתוני המערכת</strong> - חניכים, מדריכים, קבוצות, טיולים וניקוד.<br/>
            שמור אותו במקום בטוח ושמרהו לשחזור עתידי.
          </p>
          <button className="btn btn-p btn-sm mb3" onClick={()=>setShowCode(s=>!s)}>
            {showCode?"🔼 הסתר קוד":"📋 הצג קוד גיבוי"}
          </button>
          {showCode&&<>
            <textarea readOnly value={generateCode()} style={{width:"100%",minHeight:100,fontFamily:"monospace",fontSize:10,padding:10,border:`2px solid ${T.border}`,borderRadius:9,resize:"vertical",background:T.slateL,direction:"ltr"}}/>
            <button className="btn btn-g btn-sm mt2" onClick={()=>{navigator.clipboard?.writeText(generateCode()).then(()=>alert("קוד הגיבוי הועתק!"));}}>📋 העתק קוד</button>
          </>}
        </div>
      </div>
      <div className="card">
        <div className="card-h"><h3>🔄 שחזור מקוד</h3></div>
        <div className="card-b">
          <p style={{fontSize:12,color:T.muted,marginBottom:12}}>הדבק קוד גיבוי קיים כדי לשחזר את כל הנתונים</p>
          <div className="alert alert-c mb3">⚠️ שחזור יחליף את כל הנתונים הקיימים!</div>
          <textarea value={restoreCode} onChange={e=>setRestoreCode(e.target.value)} placeholder="הדבק כאן את קוד הגיבוי..." style={{width:"100%",minHeight:90,fontFamily:"monospace",fontSize:10,padding:10,border:`2px solid ${T.border}`,borderRadius:9,resize:"vertical",direction:"ltr"}}/>
          {restoreMsg&&<div className={`alert ${restoreMsg.startsWith("✅")?"alert-t":"alert-c"} mt2`}>{restoreMsg}</div>}
          <button className="btn btn-a btn-sm mt3" onClick={doRestore} disabled={!restoreCode.trim()}>🔄 שחזר נתונים</button>
        </div>
      </div>
    </div>}

    {/* Admin modal */}
    <Modal open={!!adminModal} onClose={()=>setAdminModal(null)} title={adminModal==="add"?"➕ הוסף מנהל":"✏️ עריכת מנהל"}
      footer={<><button className="btn btn-g" onClick={()=>setAdminModal(null)}>ביטול</button><button className="btn btn-p" onClick={saveAdmin}>שמור</button></>}>
      <div className="fg s1">
        <Fld label="שם מלא"><input value={adminForm.name||""} onChange={e=>setAdminForm(f=>({...f,name:e.target.value}))}/></Fld>
        <Fld label="אימייל"><input type="email" value={adminForm.email||""} onChange={e=>setAdminForm(f=>({...f,email:e.target.value}))}/></Fld>
        <Fld label="סיסמה"><input type="password" placeholder="השאר ריק לאי-שינוי" value={adminForm.password||""} onChange={e=>setAdminForm(f=>({...f,password:e.target.value}))}/></Fld>
        <Fld label="הרשאה">
          <select value={adminForm.role||"viewer"} onChange={e=>setAdminForm(f=>({...f,role:e.target.value}))}>
            {Object.entries(ADMIN_ROLES).map(([k,v])=><option key={k} value={k}>{v}</option>)}
          </select>
        </Fld>
        <Fld label="סטטוס">
          <div className="flex ic gap2">
            <Toggle on={adminForm.active!==false} onToggle={()=>setAdminForm(f=>({...f,active:!f.active}))}/>
            <span className="fs12">{adminForm.active!==false?"פעיל":"מושבת"}</span>
          </div>
        </Fld>
      </div>
    </Modal>
  </div>;
}

// ════════════════════════════════════════════════
// NAV
// ════════════════════════════════════════════════
const NAV=[
  {sec:"ניהול"},
  {id:"children",l:"חניכים",i:"👦"},
  {id:"counselors",l:"מדריכים",i:"🧑‍🏫"},
  {id:"groups",l:"קבוצות",i:"⛺"},
  {sec:"פעילות"},
  {id:"attendance",l:"נוכחות יומית",i:"📅"},
  {id:"trips",l:"טיולים",i:"🚌"},
  {id:"scores",l:"לוח ניקוד",i:"🏆"},
  {sec:"תקשורת"},
  {id:"messages",l:"הודעות",i:"📢"},
  {sec:"מערכת"},
  {id:"settings",l:"הגדרות",i:"⚙️"},
];

const TITLES={children:"חניכים",counselors:"מדריכים",groups:"קבוצות",attendance:"נוכחות יומית",trips:"טיולים",scores:"לוח ניקוד",messages:"הודעות",settings:"הגדרות"};

// ══════════════════════════════════════════════════════════════
// API CLIENT
// ══════════════════════════════════════════════════════════════
const API_BASE = (typeof process!=='undefined'&&process.env&&process.env.REACT_APP_API_URL)||'/api';
function getToken(){ return localStorage.getItem('camp_token'); }
function getUser(){ try{ return JSON.parse(localStorage.getItem('camp_user')||'null'); }catch{ return null; } }
function setAuth(token,user){ localStorage.setItem('camp_token',token); localStorage.setItem('camp_user',JSON.stringify(user)); }
function clearAuth(){ localStorage.removeItem('camp_token'); localStorage.removeItem('camp_user'); }
async function apiReq(method,path,body=null){
  const headers={'Content-Type':'application/json'};
  const token=getToken();
  if(token) headers['Authorization']=`Bearer ${token}`;
  const res=await fetch(`${API_BASE}/${path}`,{method,headers,body:body?JSON.stringify(body):undefined});
  if(res.status===401){clearAuth();window.location.reload();return;}
  const data=await res.json();
  if(!res.ok) throw new Error(data.error||'שגיאת שרת');
  return data;
}
const api={
  login:(e,p)=>apiReq('POST','auth',{email:e,password:p}),
  getChildren:(p={})=>apiReq('GET',`children?${new URLSearchParams(p)}`),
  createChild:(d)=>apiReq('POST','children',d),
  updateChild:(id,d)=>apiReq('PUT',`children/${id}`,d),
  deleteChild:(id)=>apiReq('DELETE',`children/${id}`),
  importChildren:(rows)=>apiReq('POST','children/import',rows),
  getCounselors:()=>apiReq('GET','counselors'),
  createCounselor:(d)=>apiReq('POST','counselors',d),
  updateCounselor:(id,d)=>apiReq('PUT',`counselors/${id}`,d),
  deleteCounselor:(id)=>apiReq('DELETE',`counselors/${id}`),
  getGroups:()=>apiReq('GET','groups'),
  createGroup:(d)=>apiReq('POST','groups',d),
  updateGroup:(id,d)=>apiReq('PUT',`groups/${id}`,d),
  deleteGroup:(id)=>apiReq('DELETE',`groups/${id}`),
  getTrips:()=>apiReq('GET','trips'),
  createTrip:(d)=>apiReq('POST','trips',d),
  updateTrip:(id,d)=>apiReq('PUT',`trips/${id}`,d),
  deleteTrip:(id)=>apiReq('DELETE',`trips/${id}`),
  setTripAtt:(id,d)=>apiReq('PUT',`trips/${id}/attendance`,d),
  getAttendance:(date)=>apiReq('GET',`attendance?date=${date}`),
  setAttendance:(d)=>apiReq('POST','attendance',d),
  getScores:()=>apiReq('GET','scores'),
  addScore:(d)=>apiReq('POST','scores',d),
  deleteScore:(id)=>apiReq('DELETE',`scores/${id}`),
  getTasks:()=>apiReq('GET','tasks'),
  createTask:(d)=>apiReq('POST','tasks',d),
  updateTask:(id,d)=>apiReq('PUT',`tasks/${id}`,d),
  deleteTask:(id)=>apiReq('DELETE',`tasks/${id}`),
  getSettings:()=>apiReq('GET','settings'),
  saveSettings:(d)=>apiReq('POST','settings',d),
  getAdmins:()=>apiReq('GET','admins'),
  createAdmin:(d)=>apiReq('POST','admins',d),
  updateAdmin:(id,d)=>apiReq('PUT',`admins/${id}`,d),
  deleteAdmin:(id)=>apiReq('DELETE',`admins/${id}`),
};

// ══════════════════════════════════════════════════════════════
// LOGIN PAGE
// ══════════════════════════════════════════════════════════════
const LOGIN_CSS=`
@import url('https://fonts.googleapis.com/css2?family=Heebo:wght@400;600;700;800;900&display=swap');
.lp-root{min-height:100vh;display:flex;align-items:center;justify-content:center;background:linear-gradient(135deg,#0F172A 0%,#1E1B4B 50%,#0F172A 100%);padding:20px;font-family:'Heebo',sans-serif;direction:rtl}
.lp-card{background:#fff;border-radius:24px;width:100%;max-width:420px;box-shadow:0 32px 80px rgba(0,0,0,.4);overflow:hidden}
.lp-top{background:linear-gradient(135deg,#7C3AED,#4F46E5);padding:36px 32px 28px;text-align:center;color:#fff}
.lp-emoji{font-size:52px;display:block;margin-bottom:10px}
.lp-title{font-size:26px;font-weight:900;margin:0}
.lp-sub{font-size:13px;opacity:.75;margin-top:6px}
.lp-body{padding:28px 32px 32px}
.lp-label{display:block;font-size:12px;font-weight:700;color:#475569;margin-bottom:5px}
.lp-input{width:100%;padding:12px 14px;border:2px solid #E2E8F0;border-radius:11px;font-family:'Heebo';font-size:14px;outline:none;transition:.15s;background:#FAFAFA;color:#1E293B;margin-bottom:14px;box-sizing:border-box}
.lp-input:focus{border-color:#7C3AED;background:#fff}
.lp-btn{width:100%;padding:14px;background:linear-gradient(135deg,#7C3AED,#4F46E5);color:#fff;border:none;border-radius:11px;font-family:'Heebo';font-size:15px;font-weight:800;cursor:pointer;transition:.15s;margin-top:4px}
.lp-btn:hover{opacity:.92}
.lp-btn:disabled{opacity:.5;cursor:not-allowed}
.lp-err{background:#FFE4E6;color:#9F1239;border:1px solid #FECDD3;border-radius:9px;padding:10px 14px;font-size:12px;font-weight:600;margin-bottom:14px;text-align:center}
.lp-forgot{text-align:center;margin-top:14px;font-size:12px;color:#94A3B8}
.lp-forgot span{color:#7C3AED;cursor:pointer;font-weight:700}
.lp-roles{display:flex;gap:8px;margin-top:20px;padding-top:20px;border-top:1px solid #E2E8F0}
.lp-role{flex:1;padding:8px 4px;border-radius:9px;text-align:center;font-size:10px;font-weight:700;background:#F8FAFC;color:#94A3B8;border:1px solid #E2E8F0;line-height:1.6}
.lp-spin{display:inline-block;width:16px;height:16px;border:2px solid rgba(255,255,255,.3);border-top-color:#fff;border-radius:50%;animation:lspin .7s linear infinite;vertical-align:middle;margin-left:6px}
@keyframes lspin{to{transform:rotate(360deg)}}
`;

function LoginPage({onLogin}){
  const [email,setEmail]=useState('');
  const [pass,setPass]=useState('');
  const [err,setErr]=useState('');
  const [busy,setBusy]=useState(false);
  const [forgot,setForgot]=useState(false);

  async function doLogin(e){
    e.preventDefault();
    if(!email||!pass){setErr('נא למלא אימייל וסיסמה');return;}
    setBusy(true);setErr('');
    try{
      const res=await api.login(email.trim(),pass);
      setAuth(res.token,res.user);
      onLogin(res.user);
    }catch(ex){setErr(ex.message||'שגיאת התחברות');}
    finally{setBusy(false);}
  }

  return <>
    <style>{LOGIN_CSS}</style>
    <div className="lp-root">
      <div className="lp-card">
        <div className="lp-top">
          <span className="lp-emoji">⛺</span>
          <h1 className="lp-title">קייטנה גן ישראל</h1>
          <p className="lp-sub">חדרה 2026 - מערכת ניהול</p>
        </div>
        <div className="lp-body">
          {!forgot?<>
            <form onSubmit={doLogin}>
              {err&&<div className="lp-err">⚠️ {err}</div>}
              <label className="lp-label">אימייל</label>
              <input className="lp-input" type="email" placeholder="your@email.com" value={email} onChange={e=>{setEmail(e.target.value);setErr('');}} autoFocus/>
              <label className="lp-label">סיסמה</label>
              <input className="lp-input" type="password" placeholder="••••••••" value={pass} onChange={e=>{setPass(e.target.value);setErr('');}}/>
              <button className="lp-btn" type="submit" disabled={busy}>{busy?<><span className="lp-spin"/>מתחבר...</>:'כניסה למערכת'}</button>
            </form>
            <div className="lp-forgot"><span onClick={()=>setForgot(true)}>שכחתי סיסמה</span></div>
            <div className="lp-roles">
              {[{i:'👑',l:'מנהל',d:'גישה מלאה'},{i:'🧑‍🏫',l:'מדריך',d:'הקבוצה שלי'},{i:'👨‍👩‍👦',l:'הורה',d:'הילד שלי'}].map(r=>(
                <div key={r.l} className="lp-role">{r.i}<br/>{r.l}<br/><span style={{fontSize:9,color:'#CBD5E1'}}>{r.d}</span></div>
              ))}
            </div>
          </>:<>
            <div style={{textAlign:'center',marginBottom:20}}>
              <div style={{fontSize:40}}>🔑</div>
              <div style={{fontWeight:800,fontSize:16,marginTop:10}}>איפוס סיסמה</div>
              <div style={{fontSize:12,color:'#94A3B8',marginTop:6}}>פנה למנהל המערכת לאיפוס הסיסמה</div>
            </div>
            <div style={{background:'#F0FDF4',border:'1px solid #BBF7D0',borderRadius:10,padding:'12px 16px',fontSize:12,color:'#166534',marginBottom:16,lineHeight:1.8}}>
              📧 צור קשר עם מנהל המערכת:<br/><strong>admin@camp.il</strong>
            </div>
            <button className="lp-btn" style={{background:'#475569'}} onClick={()=>setForgot(false)}>חזרה להתחברות</button>
          </>}
        </div>
      </div>
    </div>
  </>;
}

// ══════════════════════════════════════════════════════════════
// LOADING / ERROR SCREENS
// ══════════════════════════════════════════════════════════════
function LoadingScreen(){
  return <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#0F172A',fontFamily:'Heebo,sans-serif',direction:'rtl'}}>
    <div style={{textAlign:'center',color:'#fff'}}>
      <div style={{fontSize:52,marginBottom:16}}>⛺</div>
      <div style={{fontSize:18,fontWeight:800,marginBottom:16}}>טוען נתונים...</div>
      <div style={{width:200,height:4,background:'rgba(255,255,255,.1)',borderRadius:99,margin:'0 auto',overflow:'hidden'}}>
        <div style={{height:'100%',background:'#7C3AED',borderRadius:99,animation:'ldbar 1.5s ease-in-out infinite'}}/>
      </div>
      <style>{'@keyframes ldbar{0%{width:0%}50%{width:70%}100%{width:100%}}'}</style>
    </div>
  </div>;
}

// ══════════════════════════════════════════════════════════════
// ROOT APP
// ══════════════════════════════════════════════════════════════
export default function App(){
  const [user,setUser]=useState(()=>getUser());
  const [data,setData]=useState({children:[],counselors:[],groups:[],trips:[],scores:[],tasks:[],settings:{},admins:[],attendance:{}});
  const [loading,setLoading]=useState(false);
  const [loadErr,setLoadErr]=useState(null);
  const [page,setPage]=useState('children');
  const [theme,setTheme]=useState(DEFAULT_THEME);

  const themeCSS=`
    .btn-p{background:${theme.primary}!important}.btn-p:hover{background:${theme.primary}cc!important}
    .btn-t{background:${theme.secondary}!important}.btn-d{background:${theme.danger}!important}.btn-a{background:${theme.accent}!important}
    .sb-item.active{background:${theme.primary}!important}
    .chip-p{background:${theme.primary}22!important;color:${theme.primary}!important}
    .chip-t{background:${theme.secondary}22!important;color:${theme.secondary}!important}
    .chip-c{background:${theme.danger}22!important;color:${theme.danger}!important}
    .tab.active{color:${theme.primary}!important;border-bottom-color:${theme.primary}!important}
    .sidebar{background:${theme.sidebar}!important}
    .att-btn.yes{background:${theme.secondary}22!important;border-color:${theme.secondary}!important;color:${theme.secondary}!important}
  `;

  async function loadAll(){
    if(!user) return;
    setLoading(true);setLoadErr(null);
    try{
      const canAdmin=['superadmin','admin'].includes(user.role);
      const [children,counselors,groups,trips,scores,tasks,settings,admins]=await Promise.all([
        api.getChildren(),api.getCounselors(),api.getGroups(),api.getTrips(),
        api.getScores(),api.getTasks(),api.getSettings(),
        canAdmin?api.getAdmins().catch(()=>[]):Promise.resolve([]),
      ]);
      const tripsFixed=(trips||[]).map(t=>({
        ...t,
        group_ids:(t.group_ids||[]).map(Number),
        locations:Array.isArray(t.locations)?t.locations:(t.locations?JSON.parse(t.locations):[]),
        gear:typeof t.gear==='object'&&t.gear!==null?t.gear:(t.gear?JSON.parse(t.gear):{}),
        attendance:{},
      }));
      if(settings?.primary_color){
        const th={...DEFAULT_THEME,primary:settings.primary_color,secondary:settings.secondary_color||DEFAULT_THEME.secondary};
        setTheme(th);
      }
      setData({children:children||[],counselors:counselors||[],groups:groups||[],
        trips:tripsFixed,scores:scores||[],tasks:tasks||[],
        settings:settings||{},admins:admins||[],attendance:{}});
      // Set initial page based on role
      if(user.role==='counselor') setPage('attendance');
      else if(user.role==='parent') setPage('children');
    }catch(e){setLoadErr(e.message);}
    finally{setLoading(false);}
  }

  useEffect(()=>{ loadAll(); },[user]);

  // Wrap setData so each mutation also calls the API
  const sd=useCallback((updater)=>{
    setData(prev=>typeof updater==='function'?updater(prev):updater);
  },[]);

  function handleLogin(u){
    setUser(u);
  }
  function handleLogout(){
    clearAuth();setUser(null);
    setData({children:[],counselors:[],groups:[],trips:[],scores:[],tasks:[],settings:{},admins:[],attendance:{}});
  }

  if(!user) return <LoginPage onLogin={handleLogin}/>;
  if(loading) return <LoadingScreen/>;
  if(loadErr) return <div style={{minHeight:'100vh',display:'flex',alignItems:'center',justifyContent:'center',background:'#0F172A',fontFamily:'Heebo',direction:'rtl',color:'#fff',textAlign:'center',padding:24}}>
    <div><div style={{fontSize:48,marginBottom:16}}>⚠️</div><div style={{fontSize:18,fontWeight:800,marginBottom:8}}>שגיאת חיבור</div><div style={{fontSize:13,color:'rgba(255,255,255,.5)',marginBottom:24}}>{loadErr}</div><button onClick={loadAll} style={{padding:'10px 24px',background:'#7C3AED',color:'#fff',border:'none',borderRadius:10,fontFamily:'Heebo',fontSize:14,fontWeight:700,cursor:'pointer'}}>נסה שוב</button></div>
  </div>;

  const s=data.settings||{};
  const campDates=s.camp_start_date&&s.camp_end_date?`${fmtDate(s.camp_start_date)} - ${fmtDate(s.camp_end_date)}`:'';

  // Filter nav by role
  const visibleNav=NAV.filter(item=>{
    if(item.sec) return true;
    if(user.role==='counselor') return ['attendance','scores','groups'].includes(item.id);
    if(user.role==='parent') return ['children'].includes(item.id);
    return true;
  });

  return <>
    <style>{CSS}</style>
    <style>{themeCSS}</style>
    <div className="shell">
      <div className="sidebar">
        <div className="sb-brand">
          {s.logo_url
            ?<img src={s.logo_url} alt="logo" style={{height:38,objectFit:'contain',marginBottom:8,borderRadius:6,maxWidth:'100%'}}/>
            :<div className="sb-logo">⛺ {s.camp_name||'קייטנה'}</div>}
          <div className="sb-sub">{campDates||'גן ישראל חדרה 2026'}</div>
        </div>
        {visibleNav.map((item,i)=>item.sec
          ?<div key={i} className="sb-sec">{item.sec}</div>
          :<div key={item.id} className={`sb-item${page===item.id?' active':''}`} onClick={()=>setPage(item.id)}><span className="sb-icon">{item.i}</span>{item.l}</div>
        )}
        <div className="sb-footer">
          <div style={{color:'rgba(255,255,255,.3)',fontSize:10,textAlign:'center',marginBottom:6}}>
            {user.name} · {user.role==='superadmin'?'סופר מנהל':user.role==='admin'?'מנהל':user.role==='editor'?'עורך':user.role==='counselor'?'מדריך':'צופה'}
          </div>
          <button className="sb-reset" onClick={handleLogout}>🚪 התנתק</button>
        </div>
      </div>
      <div className="main-area">
        <div className="topbar">
          <div className="tb-title">{TITLES[page]}</div>
          <div className="tb-chips">
            <span className="chip chip-p">👦 {data.children.length}</span>
            <span className="chip chip-t">🧑‍🏫 {data.counselors.length}</span>
            <span className="chip chip-s">⛺ {data.groups.length}</span>
            <span className="chip chip-c">📅 {Object.values(data.attendance?.[today()]||{}).filter(v=>v===true).length}/{data.children.length} היום</span>
            <button onClick={loadAll} style={{marginRight:'auto',padding:'4px 10px',background:'rgba(124,58,237,.1)',border:'1px solid rgba(124,58,237,.2)',borderRadius:7,cursor:'pointer',fontSize:11,color:'#7C3AED',fontFamily:'Heebo',fontWeight:700}}>🔄 רענן</button>
          </div>
        </div>
        {page==='children'   &&<ChildrenPage   data={data} setData={sd} api={api} onRefresh={loadAll}/>}
        {page==='counselors' &&<CounselorsPage data={data} setData={sd} api={api} onRefresh={loadAll}/>}
        {page==='groups'     &&<GroupsPage     data={data} setData={sd} api={api} onRefresh={loadAll}/>}
        {page==='attendance' &&<AttendancePage data={data} setData={sd} api={api} onRefresh={loadAll} user={user}/>}
        {page==='trips'      &&<TripsPage      data={data} setData={sd} api={api} onRefresh={loadAll}/>}
        {page==='scores'     &&<ScoresPage     data={data} setData={sd} api={api} onRefresh={loadAll}/>}
        {page==='messages'   &&<MessagesPage   data={data}/>}
        {page==='settings'   &&<SettingsPage   data={data} setData={sd} api={api} onRefresh={loadAll} onThemeChange={setTheme}/>}
      </div>
    </div>
  </>;
}
